package DataBase

import Structs.*
import Structs.Api.ApiNote
import Utils.*
import printPlat
import kotlin.math.roundToInt

open class UINKDBInterface : NKDBInterface() {
    suspend fun fetchSpecificSupplierData(params: HashMap<String, Any>): DBQuery {
        val id = params["id"]!! as Int
        val fromDate = (params["fromDate"] as String?) ?: DatesManipulator.dateNowNoHour()
        val toDate = (params["fromDate"] as String?) ?: DatesManipulator.dateNowNoHour()
        return fetchSpecificSupplierData(listOf(id), fromDate, toDate)
    }

    suspend fun fetchSuppliers(params: HashMap<String, Any>): DBQuery {

        return fetchSuppliers()
    }

    override fun setCompany(company: String, company_id: String?, local: Boolean, web: Boolean) {
        super.setCompany(company, company_id, local, web)
        activeDB = this
    }

    fun setActiveDB() {
        activeDB = this
    }

    suspend fun badReturnCheck(): Any? {
        return null
    }

    suspend fun buildClientCreation(
        params: HashMap<String, Any>
    ): Respone<List<ClientCreation>, DBQuery> {
        return this.buildClientCreation(
        )
    }

    suspend fun getClients(
        params: HashMap<String, Any>
    ): Respone<List<Client>, DBQuery> {
        return this.buildClients(
            active = params["active"] as Boolean?,
            fromDate = params["date"] as String,
            toDate = params["date"] as String,
            branch = params["branch"] as Int?,
            withDaily = (params["withDaily"] as Boolean) ?: false
        )
    }

    suspend fun buildClientsDailyData(
        params: HashMap<String, Any>
    ): Respone<List<ClientDailyData>, DBQuery> {
        val singleDriverId = params["driver_id"] as Int?
        val multiDriverId = params["driver_ids"] as List<Int>?
        val singleCollectorId = params["collector_id"] as Int?
        val multiCollectorId = params["collector_ids"] as List<Int>?
        return this.buildClientsDailyData(
            id = params["id"] as Int?,
            date = params["date"] as String,
            driver_id = multiDriverId ?: singleDriverId?.let { listOf(it) },
            collector_id = multiCollectorId ?: singleCollectorId?.let { listOf(it) },
            day = params["day"] as Int?,
            ids = params["ids"] as List<Int>?
        )
    }

    suspend fun newClientsAllDailyData(
        params: HashMap<String, Any>
    ): Respone<List<ClientDailyData>, DBQuery> {
        val day = params["day"] as Int?
        var date = params["date"] as String?
        val toDate = params["toDate"] as String?
        if (day != null) {
            date = baseOrderDaysToData[day]

        }

        return this.newClientAllDailyData(
            date = date!!,
            daily = params["data"] as List<ClientDailyData>,
            dailyFinder = params["dailyFinder"] as Boolean? ?: false,
            toDate = toDate,
        )
    }

    suspend fun newClientsDailyData(
        params: HashMap<String, Any>
    ): Respone<List<ClientDailyData>, DBQuery> {
        return this.newClientDailyData(
            id = params["id"] as Int,
            date = params["date"] as String,
            driver_id = params["driver_id"] as Int,
            collector_id = params["collector_id"] as Int,
            position = params["position"] as Int,
            car = params["car"] as String ?: "",
        )
    }

    private fun paramsImageBytes(params: HashMap<String, Any>): ByteArray? {
        return params["image"] as? ByteArray
    }

    suspend fun newClient(
        params: HashMap<String, Any>
    ): Respone<Client?, DBQuery> {
        val result = this.newClient(
            agent = params["agent"]!! as String,
            date = params["date"] as String,
            name = params["name"]!! as String,
            include_tax = params["include_tax"] as Int?,
            business_name = params["business_name"] as String?,
            business_id = params["business_id"] as String?,
            address = params["address"] as String?,
            print_state = params["print_state"] as Int?,
            phone = params["phone"] as String?,
            phone_contact = params["personalNamePhone"] as String?,
            branch = params["branch"] as Int?,
            master = params["master"] as Int?,
            discount = params["discount"] as Float?,
            email = params["email"] as String?,
            external_id = params["external_id"] as String?,
            day = (params["day"] as Int?) ?: params["days"] as Int?,
            notes = params["notes"] as Int?,
            no_tax_client = params["no_tax_client"] as Int?,
            comments = params["comments"] as String?,
            min_order = params["min_order"] as Int?,
            id = params["id"] as Int?,
            location = params["location"] as String?,
            category = params["category"] as String?,
            obligo = params["obligo"] as Float?,
            price_control = params["price_control"] as Int?,
            available_control = params["available_control"] as Int?,
            payment_notes = params["payment_notes"] as String?,
            category2 = params["category2"] as String?,
            driver = params["driver"] as String?,
            min_order_sum = params["min_order_sum"] as Float?,
            tax_note_type = params["tax_note_type"] as Int?,
            days_to_pay = params["days_to_pay"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            notes6 = params["notes6"] as String?,
            notes7 = params["notes7"] as String?,
            notes8 = params["notes8"] as String?,
            notes9 = params["notes9"] as String?,
            notes10 = params["notes10"] as String?,
            notes11 = params["notes11"] as String?,
            notes12 = params["notes12"] as String?,
            date_contact = params["date_contact"] as String?,
            net_split = params["net_split"] as Int?,

            link = params["link"] as Int?,
            from_hour = params["from_hour"] as String?,
            to_hour = params["to_hour"] as String?,
            name_english = params["name_english"] as String?,
            address_english = params["address_english"] as String?,
            cc_token = params["cc_token"] as String?,
            cc_expiry = params["cc_expiry"] as String?,
            cofc_lock = params["cofc_lock"] as Int?,
            arrival_instructions = params["arrival_instructions"] as String?,
            card_image = params["card_image"] as Int? ?: paramsImageBytes(params)?.let { 1 },
            return_pct = (params["return_pct"] as? Number)?.toFloat(),
        )
        if (result.second == DBQuery.SUCCESS) {
            val imageBytes = paramsImageBytes(params)
            val clientId = result.first?.id
            if (imageBytes != null && clientId != null) {
                this.uploadClientCardImage(imageBytes, clientId)
            }
        }
        return result
    }

    suspend fun getClientBranch(
        params: HashMap<String, Any>
    ): Respone<List<Client>, DBQuery> {
        return this.buildClients(
            active = params["active"] as Boolean?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            branch = params["branch"] as Int?,
        )
    }

    suspend fun updateDriver(
        params: HashMap<String, Any>
    ): DBQuery {
        val driver = (params["driver"] as String).let { d ->
            getAgents().first.filter { it.isDriver() }.firstOrNull { it.user_name == d }
        } ?: return DBQuery.FAILED
        val id = params["id"] as Int
        val all_base = params["all_base"] as Boolean
        val fromDate = params["fromDate"] as String?
        val p = updateDriverAll(id, driver.id, all_base, fromDate)
        return p
    }

    suspend fun updateClient(
        params: HashMap<String, Any>
    ): Respone<Client?, DBQuery> {
        val result = this.updateClient(
            id = params["id"]!! as Int,
            date = params["date"] as String,
            agent = params["agent"] as String?,
            name = params["name"] as String?,
            include_tax = params["include_tax"] as Int?,
            business_name = params["business_name"] as String?,
            business_id = params["business_id"] as String?,
            address = params["address"] as String?,
            print_state = params["print_state"] as Int?,
            position = params["position"] as Int?,
            active = params["active"] as Int?,
            phone = params["phone"] as String?,
            phone_contact = (params["personalNamePhone"] as String?) ?: params["phone_contact"] as String?,
            branch = params["branch"] as Int?,
            master = params["master"] as Int?,
            discount = params["discount"] as Float?,
            email = params["email"] as String?,
            external_id = params["external_id"] as String?,
            day = params["day"] as Int?,
            notes = params["notes"] as Int?,
            no_tax_client = params["no_tax_client"] as Int?,
            comments = params["comments"] as String?,
            min_order = params["min_order"] as Int?,
            location = params["location"] as String?,
            category = params["category"] as String?,
            obligo = params["obligo"] as Float?,
            price_control = params["price_control"] as Int?,
            available_control = params["available_control"] as Int?,
            payment_notes = params["payment_notes"] as String?,
            category2 = params["category2"] as String?,
            driver = params["driver"] as String?,
            min_order_sum = params["min_order_sum"] as Float?,
            tax_note_type = params["tax_note_type"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            notes6 = params["notes6"] as String?,
            notes7 = params["notes7"] as String?,
            notes8 = params["notes8"] as String?,
            notes9 = params["notes9"] as String?,
            notes10 = params["notes10"] as String?,
            notes11 = params["notes11"] as String?,
            notes12 = params["notes12"] as String?,
            days_to_pay = params["days_to_pay"] as Int?,
            net_split = params["net_split"] as Int?,
            link = params["link"] as Int?,
            from_hour = params["from_hour"] as String?,
            to_hour = params["to_hour"] as String?,
            name_english = params["name_english"] as String?,
            address_english = params["address_english"] as String?,
            cc_token = params["cc_token"] as String?,
            cc_expiry = params["cc_expiry"] as String?,
            cofc_lock = params["cofc_lock"] as Int?,
            arrival_instructions = params["arrival_instructions"] as String?,
            card_image = params["card_image"] as Int? ?: paramsImageBytes(params)?.let { 1 },
            return_pct = (params["return_pct"] as? Number)?.toFloat(),
        )
        if (result.second == DBQuery.SUCCESS) {
            val imageBytes = paramsImageBytes(params)
            val clientId = result.first?.id ?: (params["id"] as? Number)?.toInt()
            if (imageBytes != null && clientId != null) {
                this.uploadClientCardImage(imageBytes, clientId)
            }
        }
        return result
    }


    suspend fun newClientProduct(
        params: HashMap<String, Any>
    ): Respone<Product?, DBQuery> {
        return this.newClientProduct(
            name = params["name"]!! as String,
            date = params["date"]!! as String,
            barcode = params["barcode"] as String?,
            default_price = params["default_price"] as Float?,
            no_tax_product = params["no_tax_product"] as Int?,
            external_id = params["external_id"] as String?,
            unit = params["unit"] as Int?,
            unit_amount = params["unit_amount"] as Float?,
            category = params["category"] as String?,
            cost_price = params["cost_price"] as Float?,
            split_category = params["split_category"] as Int?,
            category2 = params["category2"] as String?,
            p_range = params["p_range"] as Float?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            notes6 = params["notes6"] as String?,
            )
    }


    suspend fun updateClientProduct(
        params: HashMap<String, Any>
    ): Respone<Product?, DBQuery> {
        return this.updateClientProduct(
            id = params["id"]!! as Int,
            name = params["name"] as String?,
            date = params["date"] as String,
            barcode = params["barcode"] as String?,
            default_price = params["default_price"] as Float?,
            position = params["position"] as Int?,
            active = params["active"] as Int?,
            no_tax_product = params["no_tax_product"] as Int?,
            taklit_id = params["taklit_id"] as Int?,
            taklit_type = params["taklit_type"] as Int?,
            external_id = params["external_id"] as String?,
            unit = params["unit"] as Int?,
            unit_amount = params["unit_amount"] as Float?,
            category = params["category"] as String?,
            cost_price = params["cost_price"] as Float?,
            split_category = params["split_category"] as Int?,
            p_range = params["p_range"] as Float?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            notes6 = params["notes6"] as String?,

        )
    }

    suspend fun updateClientAllupdateClientAllData(
        params: HashMap<String, Any>
    ): Respone<List<Client>, DBQuery> {
        return this.updateClientAllData(
            mapper = params["mapper"] as List<Map<String, Any>>,
            ids = params["ids"] as List<Int>?
        )
    }

    suspend fun updateAllOrderProduct(
        params: HashMap<String, Any>
    ): Respone<List<OrderProduct>, DBQuery> {
        return this.updateAllOrderProduct(
            mapper = params["mapper"] as List<Map<String, Any>>
        )
    }

    suspend fun updateClientAllProduct(
        params: HashMap<String, Any>
    ): Respone<List<Product>, DBQuery> {
        return this.updateClientAllProduct(
            mapper = params["mapper"] as List<Map<String, Any>>,
            full = (params["full"] as Boolean?) ?: false
        )
    }

    suspend fun updateClientProductPosition(params: HashMap<String, Any>): DBQuery {
        val new_p_list = params["products"] as List<Product>

        val maps = new_p_list.mapIndexed { index: Int, it: Product ->
            val map: MutableMap<String, Any> = mutableMapOf()
            map["product_id"] = it.id
            map["id"] = it.id
            map["position"] = index
            map
        }

        // Catalog order is a month version, same date as a product edit (yyyy-MM-01).
        val monthStart = DatesManipulator.minDay(DatesManipulator.dateNowNoHour())
        return updateClientAllProduct(maps, false, date = monthStart).second
    }

    /**
     * Row shape of the customer-list bulk save (`customerToNewObject`).
     * Own-row fields are sent as stored; [position] is the only value the reorder changes.
     */
    private fun clientToBulkUpdateMap(client: Client, position: Int): Map<String, Any> {
        val map = mutableMapOf<String, Any>(
            "id" to client.id,
            "name" to client.name,
            "agent" to client.agent,
            "include_tax" to client.include_tax,
            "no_tax_client" to client.no_tax_client,
            "business_name" to client.business_name,
            "business_id" to client.business_id,
            "address" to (client.address ?: ""),
            "print_state" to client.print_state,
            "phone" to (client.phone ?: ""),
            "phone_contact" to client.phone_contact,
            "category" to client.category,
            "branch" to client.branch,
            "master" to client.master,
            "position" to position,
            "active" to client.active,
            "comments" to client.comments,
            "arrival_instructions" to client.arrival_instructions,
            "card_image" to client.card_image,
            "email" to client.email,
            "discount" to client.discount,
            "external_id" to client.external_id,
            "day" to client.days,
            "notes" to client.notes,
            "min_order" to client.min_order,
            "min_order_sum" to client.min_order_sum,
            "return_pct" to client.return_pct,
            "location" to (client.location ?: ""),
            "obligo" to client.obligo,
            "price_control" to client.price_control,
            "available_control" to client.available_control,
            "cofc_lock" to client.cofc_lock,
            "tax_note_type" to client.tax_note_type,
            "payment_notes" to client.payment_notes,
            "days_to_pay" to client.days_to_pay,
            "date_contact" to (client.date_contact ?: ""),
            "notes2" to client.notes2,
            "notes3" to client.notes3,
            "notes4" to client.notes4,
            "notes5" to client.notes5,
            "notes6" to client.notes6,
            "notes7" to client.notes7,
            "notes8" to client.notes8,
            "notes9" to client.notes9,
            "notes10" to client.notes10,
            "notes11" to client.notes11,
            "notes12" to client.notes12,
            "net_split" to client.net_split,
            "name_english" to (client.name_english ?: ""),
            "address_english" to (client.address_english ?: ""),
            "category2" to client.category2,
            "from_hour" to client.from_hour,
            "to_hour" to client.to_hour,
        )
        client.link?.let { map["link"] = it }
        client.cc_token?.let { map["cc_token"] = it }
        client.cc_expiry?.let { map["cc_expiry"] = it }
        client.getDriver()?.user_name?.takeIf { it.isNotBlank() }?.let { map["driver"] = it }
        client.edi?.let { edi ->
            map["edi_sup_id"] = edi.edi_sup_id
            map["edi_client_id"] = edi.edi_client_id
            map["net_edi"] = edi.net_edi
            map["internal_sup_edi"] = edi.internal_sup_edi
            map["branch_number"] = edi.branch_number
        }
        return map
    }

    /**
     * Same bulk save as the customer list (`UPDATE_CLIENT_ALL` / changeAllCustomers).
     * Each row is the current client with `position` set to its new index, so the
     * server can update position together with the rest of the client.
     */
    suspend fun updateClientPosition(params: HashMap<String, Any>): DBQuery {
        val clients = params["clients"] as List<Client>
        if (clients.isEmpty()) return DBQuery.SUCCESS
        val maps = clients.mapIndexed { index, client -> clientToBulkUpdateMap(client, index) }
        return updateClientAllData(mapper = maps, ids = clients.map { it.id }).second
    }

    suspend fun updateSupplierProductPosition(params: HashMap<String, Any>): DBQuery {
        val new_p_list = params["products"] as List<Product>

        val maps = new_p_list.mapIndexed { index: Int, it: Product ->
            val map: MutableMap<String, Any> = mutableMapOf()
            map["id"] = it.id
            map["position"] = index
            map
        }

        val monthStart = DatesManipulator.minDay(DatesManipulator.dateNowNoHour())
        return updateSupplierAllProduct(maps, date = monthStart).second
    }

    suspend fun updateAllClientProduct(params: HashMap<String, Any>): Respone<List<Product>, DBQuery> {
        val new_p_list = params["products"] as List<Int>
        val category = params["category"] as String?
        val category2 = params["category2"] as String?
        val position = params["position"] as Int?
        val no_tax_product = params["no_tax_product"] as Int?
        val available = params["available"] as Boolean?
        val sales = params["sales"] as Int?
        val min_order = params["min_order"] as Int?
        val forceLock = params["forceLock"] as Int?
        val hourLock = params["hourLock"] as String?
        val dayLock = params["dayLock"] as Int?
        val step = params["step"] as Int?
        val collector = params["collector"] as Int?
        val unit_preferece = params["unit_preferece"] as Int?
        val armor = params["armor"] as Float?
        val days_ahead = params["days_ahead"] as Int?
        val unitStr = params["unit"] as String?
        val unit = unitStr?.let { WrappedName.convertFrom(unitStr) }?.state
        val extra_unitStr = params["extra_unit"] as String?
        val extra_unit = extra_unitStr?.let { WrappedName.convertFrom(extra_unitStr) }?.state
        val unit_amount = params["unit_amount"] as Float?
        val conversion_rate = params["conversion_rate"] as Float?


        val o_maps =
            if (available != null || sales != null || min_order != null || forceLock != null || hourLock != null || dayLock != null || step != null || collector != null || unit_preferece != null || extra_unit != null || conversion_rate != null || armor != null || days_ahead != null)
                new_p_list.mapIndexed { index: Int, it: Int ->
                    val map: MutableMap<String, Any> = mutableMapOf()
                    map["id"] = it
                    available?.let { map["available"] = if (available) 1 else 0 }
                    position.let { map["position"] = index }
                    sales?.let { map["sales"] = sales }
                    min_order?.let { map["min_order"] = min_order }
                    forceLock?.let { map["forceLock"] = forceLock }
                    hourLock?.let { map["hourLock"] = hourLock }
                    dayLock?.let { map["dayLock"] = dayLock }
                    step?.let { map["step"] = step }
                    unit_preferece?.let { map["unit_preferece"] = unit_preferece }
                    collector?.let { map["collector"] = collector }

                    extra_unit?.let { map["extra_unit"] = extra_unit }

                    conversion_rate?.let { map["conversion_rate"] = conversion_rate }
                    armor?.let { map["armor"] = armor }
                    days_ahead?.let { map["days_ahead"] = days_ahead }

                    map
                }
            else
                null


        val o_maps_call = o_maps?.let { updateAllOrderProduct(o_maps) } ?: Respone(listOf(), DBQuery.SUCCESS)
        if (o_maps_call.second != DBQuery.SUCCESS) {
            return Respone(listOf(), DBQuery.FAILED)
        }
        val maps =
            if (category != null || category2 != null || position != null || no_tax_product != null || unit != null || unit_amount != null) new_p_list.mapIndexed { index: Int, it: Int ->
                val map: MutableMap<String, Any> = mutableMapOf()
                map["id"] = it
                map["product_id"] = it
                position?.let { map["position"] = index }
                category?.let { map["category"] = category }
                category2?.let { map["category2"] = category2 }
                unit?.let { map["unit"] = unit }
                unit_amount?.let { map["unit_amount"] = unit_amount }
                no_tax_product?.let { map["no_tax_product"] = no_tax_product }
                map
            } else null

        return maps?.let { updateClientAllProduct(maps, false) } ?: getClientProduct(new_p_list)
    }

    suspend fun buildSupplierProducts(params: HashMap<String, Any>): Respone<List<Product>, DBQuery> {
        return this.buildSupplierProducts(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            attach = params["attach"] as Boolean?,
        )
    }

    suspend fun buildClientProducts(params: HashMap<String, Any>): Respone<List<Product>, DBQuery> {
        return this.buildClientProducts(
            id = (params["id"] as Int?),
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            cost = params["cost"] as Boolean? ?: false,
            ids = (params["ids"] as List<Int>?)
        )
    }

    suspend fun buildLatestClientPrices(params: HashMap<String, Any>): Respone<List<RawPrice>, DBQuery> {
        return this.buildLatestClientPrices(
            ids = (params["ids"] as List<Int>?),
            product_id = (params["product_id"] as Int?),
        )
    }

    suspend fun buildClientSpecialPrice(params: HashMap<String, Any>): Respone<List<RawPrice>, DBQuery> {
        return this.buildClientCosts(
            ids = params["ids"] as List<Int>,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String
        )
    }

    suspend fun buildClientPriorityPrices(params: HashMap<String, Any>): Respone<List<RawPrice>, DBQuery> {
        return this.buildClientPriorityPrices(
            id = (params["ids"] as List<Int>),
            date = params["date"] as String,
        )
    }

    suspend fun getSoldProducts(params: HashMap<String, Any>): Respone<List<Pair<Int, Int>>, DBQuery> {
        return this.getSoldProducts(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            byEnt = (params["ids"] as List<Int>?),
        )
    }

    suspend fun buildClientPrices(params: HashMap<String, Any>): Respone<List<RawPrice>, DBQuery> {
        return this.buildClientPrices(
            id = (params["ids"] as List<Int>?) ?: (params["id"] as Int?)?.let { listOf(it) },
            product_id = (params["product_ids"] as List<Int>?)
                ?: (params["product_id"] as Int?)?.let { listOf(it) },
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            available = params["available"] as Boolean?,
            cost = params["cost"] as Boolean? ?: false,
            priceTuples = params["priceTuples"] as String? ?: params["price_tuple"] as String?,
            changesOnly = _paramTruthy(params, "changesOnly", "changes_only"),
        )
    }

    private fun _paramTruthy(params: HashMap<String, Any>, vararg keys: String): Boolean {
        for (key in keys) {
            when (val v = params[key]) {
                null -> continue
                is Boolean -> return v
                is Number -> return v.toInt() != 0
                is String -> {
                    val s = v.trim().lowercase()
                    if (s in listOf("1", "true", "yes", "y")) return true
                    if (s in listOf("0", "false", "no", "n", "")) return false
                }
            }
        }
        return false
    }

    suspend fun buildClientBranchNotes(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {
        return if ("date_holder" in params)
            this.buildClientNotes(
                client_ids = params["clients"] as List<Int>,
                datesHolder = params["date_holder"] as DatesHolder,
                full = params["full"] as Boolean? ?: false,
                open = params["open"] as Boolean?,
            )
        else
            this.buildClientNotes(
                client_ids = params["clients"] as List<Int>,
                full = params["full"] as Boolean? ?: false,
                open = params["open"] as Boolean?,

                )
    }

    suspend fun newClientPrice(
        params: HashMap<String, Any>
    ): Respone<RawPrice?, DBQuery> {
        return this.newClientPrice(
            id = params["id"]!! as Int,
            product_id = params["product_id"]!! as Int,
            price = params["price"]!! as Float,
            date = params["date"] as String?,
            discount = params["discount"] as Float? ?: 0f,
            toDate = params["toDate"] as String?,
        )
    }

    suspend fun updateAllSpecialProductPrice(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.updateAllSpecialProductPrice(
            ids = params["ids"] as List<Int>,
            product_id = params["product_ids"]!! as List<Int>,
            price = params["price"] as Float?,
            date = params["date"] as String,
            percent = params["percent"] as Float?,
            tax_mutate = (params["tax_mutate"] as Boolean?) ?: true,
            percent_price = params["percent_price"] as Float?,
            toDate = params["toDate"] as String?,
            byPrice = params["byPrice"] as Float?,
            unique = params["unique"] as Boolean?,
        )
    }


    suspend fun updateAllClientProductPrice(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.updateAllClientProductPrice(
            ids = params["ids"] as List<Int>?,
            product_id = params["product_ids"]!! as List<Int>,
            price = params["price"] as Float?,
            date = params["date"] as String,
            percent = params["percent"] as Float?,
            tax_mutate = (params["tax_mutate"] as Boolean?) ?: true,
            percent_price = params["percent_price"] as Float?,
            toDate = params["toDate"] as String?,
            byPrice = params["byPrice"] as Float?,
            unique = params["unique"] as Boolean?,
            baseChange = (params["baseChange"] as Boolean?) ?: false,
            alreadyPrice = (params["alreadyPrice"] as Boolean?) ?: false,
        )
    }

    suspend fun updateAllPrice(
        params: HashMap<String, Any>
    ): DBQuery {
        val isSupplier = (params["supplier"] as Boolean?) ?: false
        return if (isSupplier) this.updateAllSupplierProductPrice(
            ids = params["ids"] as List<Int>?,
            product_ids = params["product_ids"] as List<Int>?,
            date = params["date"] as String,
            toDate = params["toDate"] as String?,
            prices = params["prices"] as List<RawPrice>,
            unique = (params["unique"] as Boolean?) ?: false,
        ) else this.updateAllClientProductPrice(
            ids = params["ids"] as List<Int>?,
            product_ids = params["product_ids"] as List<Int>?,
            date = params["date"] as String,
            toDate = params["toDate"] as String?,
            prices = params["prices"] as List<RawPrice>,
            availables = params["availables"] as List<Int>?,
            unique = (params["unique"] as Boolean?) ?: false,

            )
    }

    suspend fun getSuppliers(
        params: HashMap<String, Any>
    ): Respone<List<Supplier>, DBQuery> {
        return this.buildSuppliers(
            active = (params["active"] as Boolean?)?.let { (it).toInt() },
            fromDate = params["date"] as String,
            toDate = params["date"] as String,
        )
    }

    suspend fun updateAllSuppliersProductPrice(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.updateAllSuppliersProductPrice(
            ids = params["ids"] as List<Int>?,
            product_id = params["product_ids"]!! as List<Int>,
            price = params["price"] as Float?,
            date = params["date"] as String,
            percent = params["percent"] as Float?,
            tax_mutate = (params["tax_mutate"] as Boolean?) ?: true,
            percent_price = params["percent_price"] as Float?,
            toDate = params["toDate"] as String?,
            byPrice = params["byPrice"] as Float?,
            unique = params["unique"] as Boolean?,
        )
    }

    suspend fun buildClientVisitNote(
        params: HashMap<String, Any>
    ): Respone<List<VisitNote>, DBQuery> {
        return this.buildClientVisitNote(
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            ids = params["ids"] as List<Int>?,
            ent_ids = params["ent_ids"] as List<Int>?,
            states = params["states"] as List<Int>?,
            full = (params["full"] as Boolean?) ?: false,
        )
    }

    suspend fun newClientVisitNote(
        params: HashMap<String, Any>
    ): Respone<VisitNote?, DBQuery> {

        return this.newClientVisitNote(
            client_id = params["client_id"] as Int,
            agent = params["agent"] as String,
            document_date = params["document_date"] as String,
            date_issued = params["date_issued"] as String,
            lon_lat = params["lon_lat"] as String,
            states = params["states"] as List<Int>,
            comment = params["comment"] as String,
            order_id = params["order_id"] as Int?,
            pd = params["pd"] as ProductDelivery?,
            payment = params["payment"] as Float?,
            f = params["image"] as ByteArray?,
            delivery_value = params["delivery_value"] as List<ProductDelivery>?,

            )
    }

    suspend fun updateClientVisitNote(
        params: HashMap<String, Any>
    ): Respone<VisitNote?, DBQuery> {
        return this.updateClientVisitNote(
            id = params["id"] as Int,
            comment = params["comment"] as String?,
            payment = params["payment"] as Float?,
            pd = params["pd"] as ProductDelivery?,
            states = params["states"] as List<Int>?,
            active = params["active"] as Boolean?,
            order_id = params["order_id"] as Int?,
            date = params["date"] as String?,
            delivery_value = params["delivery_value"] as List<ProductDelivery>?,
        )
    }


    suspend fun buildClientNotes(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {

        return if (params.containsKey("last")) {
            this.buildClientLastNotes(
                client_id = params["client_id"] as Int,
                full = params["full"] as Boolean? ?: false,
                limit = params["limit"] as Int?,
            )
        } else {
            if (params.containsKey("date_holder")) {
                this.buildClientNotes(
                    client_id = params["client_id"] as Int?,
                    datesHolder = params["date_holder"] as DatesHolder,
                    full = params["full"] as Boolean? ?: false
                )
            } else {
                val client_ids = (params["client_ids"] as List<Int>?) ?: (params["client_id"] as Int?)?.let {

                    if ((params["branched"] as Boolean?) ?: false) {
                        val branch = getClient(it).first?.branch
                        branch?.let { br ->
                            if (br != -1) getBranchMembers(br).first.map { it.id }
                            else listOf(it)
                        } ?: listOf(it)
                    } else listOf(it)

                }
                this.buildClientNotes(
                    client_ids = client_ids,
                    delivery_id = params["id"] as Int?,
                    fromDate = params["fromDate"] as String?,
                    toDate = params["toDate"] as String?,
                    full = params["full"] as Boolean? ?: false,
                    open = params["open"] as Boolean?,
                    api = params["api"] as Boolean? ?: false,
                    orders_ids = params["order_ids"] as List<Int>?,
                    priced = params["priced"] as Boolean? ?:false
                )
            }
        }

    }

    suspend fun buildClientEdiNotes(
        params: HashMap<String, Any>
    ): Respone<List<EdiNote>, DBQuery> {
        val ids = params["id"]?.let { listOf(it as Int) }
        return this.buildClientEdiNotes(
            note_id = ids ?: (params["note_id"] as List<Int>?),
            connected_id = params["connected_id"] as Long?,
            send = params["send"] as Boolean?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            full = params["full"] as Boolean? ?: false
        )


    }

    suspend fun newClientDeliveryNote(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {
        val fromOrder = params["fromOrder"] as Boolean?
        var order_id = params["order_id"] as Int?
        if (order_id == null && fromOrder == true) {
            val o = newClientOrderNote(
                agent = params["agent"]!! as String,
                ent_id = params["ent_id"]!! as Int,
                date = params["date"]!! as String,
                date_issued = params["date_issued"]!! as String,
                delivery_value = params["delivery_value"]!! as List<ProductDelivery>,
                sup_delivery_value = listOf(),
                notes = params["notes"] as String?,
                notes2 = params["notes2"] as String?,
                notes3 = params["notes3"] as String?,
                notes4 = params["notes4"] as String?,
                notes5 = params["notes5"] as String?,
            )
            order_id = o.first?.id

        }
        return this.newClientDeliveryNote(
            agent = params["agent"]!! as String,
            ent_id = params["ent_id"]!! as Int,
            date = params["date"]!! as String,
            date_issued = params["date_issued"]!! as String,
            delivery_value = params["delivery_value"]!! as List<ProductDelivery>,
            with_price = params["with_price"] as Boolean? ?: false,
            connected_id = params["connected_id"] as Long?,
            notes = params["notes"] as String?,
            order_id = order_id,
            increase_id = (params["increase_id"] as Int?) ?: 0,
            delivery_id = params["delivery_id"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            agent_id = params["agent_id"] as Int?,
            static_data = params["static_data"] as ClientStaticData?,
            force = params["force"] as Boolean? ?: false
        )
    }

    suspend fun updateClientNote(
        params: HashMap<String, Any>
    ): Respone<DeliveryNote?, DBQuery> {
        return this.updateClientNote(
            delivery_id = params["id"] as Int,
            paid = params["paid"] as Int?,
            active = params["active"] as Int?,
            connected_id = params["connected_id"] as Long?,
            delivery_value = params["delivery_value"] as List<ProductDelivery>?,
            order_id = params["order_id"] as Int?,
            notes = params["notes"] as String?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            agent_id = params["agent_id"] as Int?,
            updatePrice = params["updatePrice"] as Boolean?,
            agentEdit = params["agentEdit"] as String?,
            date = params["date"] as String?,
            ent_id = params["ent_id"] as Int?,
            static_data = params["static_data"] as ClientStaticData?,

            )
    }

    suspend fun buildClientBaseOrderNotes(
        params: HashMap<String, Any>
    ): Respone<List<OrderNote>, DBQuery> {
        return this.getClientBaseOrderNotes(
            day = params["day"] as Int,
            client_ids = params["client_ids"] as List<Int>?,
            full = params["full"] as Boolean? ?: false,
        )
    }


    suspend fun buildClientOrderNotes(
        params: HashMap<String, Any>
    ): Respone<List<OrderNote>, DBQuery> {

        return if (params.containsKey("last")) {
            this.buildClientLastOrderNotes(
                client_id = params["client_id"] as Int,
                full = params["full"] as Boolean? ?: false,
                limit = params["limit"] as Int?,
            )
        } else {
            this.buildClientOrderNotes(
                client_id = params["client_id"] as Int?,
                order_id = params["order_id"] as Int?,
                fromDate = params["fromDate"] as String?,
                toDate = params["toDate"] as String?,
                full = params["full"] as Boolean? ?: false,
                withoutInventory = params["withoutInventory"] as Boolean? ?: false,
                order_ids = params["order_ids"] as List<Int>?,
                client_ids = params["client_ids"] as List<Int>?,
                status = params["status"] as List<Int>?,
                inverse_status = params["inverse_status"] as List<Int>?,
                ref_id = params["ref_id"] as List<String>?,
                agent_id = params["agent_id"] as List<Int>?,
                api = params["api"] as Boolean? ?: false,
                priced = params["priced"] as Boolean? ?: false,
            )
        }
    }


    suspend fun newInventoryNote(params: HashMap<String, Any>): Respone<List<OrderNote>, DBQuery> {
        return this.newInventoryNote(
            params["agents"] as List<String>,
            params["date"] as String,
            params["delivery_value"] as List<List<ProductDelivery>>,
            params["sup_delivery_value"] as List<List<ProductDelivery>>,
            params["orders"] as List<Int>,
            agent_ids = params["agent_ids"] as List<Int>?,
            ref_ids = params["ref_ids"] as List<String?>?,
        )
    }
    suspend fun getDailySummery(params: HashMap<String, Any>): Respone<DailySummery, DBQuery> {
       val fromDate = params["fromDate"] as String
         val toDate = params["toDate"] as String
        val agent = params["agent"] as String?
        val taxNotes = buildClientTaxNote(
            fromDate = fromDate,
            toDate = toDate,
            agents = agent?.let { listOf(agent) },
        )
        val payments = buildClientPay(
            fromDate = fromDate,
            toDate = toDate,
            agents = agent?.let { listOf(agent) },
        )
        val visits = buildClientVisitNote(
            fromDate = fromDate,
            toDate = toDate,

        ).first.filter { agent==null || it.agent==agent }
        val visitClients= buildClientVisitDistinct(fromDate,toDate,null).first
        val totalValue = queryData(fromDate, toDate, byAgent = agent?.let { listOf(agent) }, byMoney = true, byProduct = listOf(-1))

        val pays:List<InformationBase> = payments.first + taxNotes.first.filter { it.taxNoteType==TaxNoteType.WITH_PAYMENT } + visits.filter { (it.payment?:0f)>0 }
        val tax = taxNotes.first + visits.filter { it.value>0f }



        val invoicesRegularVal = taxNotes.first.filter { it.taxNoteType == TaxNoteType.REGULAR }.sumOf { it.total_value.toDouble() }.toFloat()
        val invoicesWithPaymentVal = taxNotes.first.filter { it.taxNoteType == TaxNoteType.WITH_PAYMENT }.sumOf { it.total_value.toDouble() }.toFloat()
        val creditNotesVal = taxNotes.first.filter { it.taxNoteType == TaxNoteType.CANCEL }.sumOf { it.total_value.toDouble() }.toFloat()

        return Respone(DailySummery(
             sales =totalValue.first?.sumOf { ((it?.byMoney?:0f)+ (it?.byMoneyJoin ?:0f)).toDouble() }?.toFloat()?:0f,
            items = totalValue.first?.sumOf { ((it?.valueSum?:0f)+ (it?.valueSumSecJoin ?:0f)).toDouble() }?.toFloat()?:0f,
           invoices = invoicesRegularVal + invoicesWithPaymentVal - creditNotesVal,
           invoicesRegular = invoicesRegularVal,
           invoicesWithPayment = invoicesWithPaymentVal,
           creditNotes = creditNotesVal,
         receiptsSum = pays.sumOf { it.getConnectedPayment().toDouble() }.toFloat(),
        receiptsCount = pays.size,
            visits = visitClients.size,


         cash =pays.sumOf { it.getConnectedPaymentCash().toDouble() }.toFloat(),
         checks = pays.sumOf { it.getConnectedPaymentCheck().toDouble() }.toFloat(),
        credit = pays.sumOf { it.getConnectedPaymentCredit().toDouble() }.toFloat(),
            transfer = pays.sumOf { it.getConnectedPaymentBank().toDouble() }.toFloat(),

        taxDeduction = pays.sumOf { it.getConnectedPaymentMass().toDouble() }.toFloat(),
         payments =pays,
         taxes = tax
        ),DBQuery.SUCCESS)


    }

    suspend fun newInventoryNoteWeb(params: HashMap<String, Any>): DBQuery {

        val data = params["data"] as List<InventoryItem>
        val type = params["inv_type"] as Int

        if (type == 1 || type == 2) {
            // reverse the current inventory
            val inv = getInventory(
                toDate = params["date"] as String,
                inv_type = listOf(0, 2)
            )
            val invLast = getInventory(
                toDate = DatesManipulator.getNextDay(params["date"] as String, -1),
                inv_type = listOf(1)
            )
            if (inv.second != DBQuery.SUCCESS || invLast.second != DBQuery.SUCCESS) {
                return inv.second
            }
            val totalInv = inv.first.map { Pair(it.agent_id, it.product_id) to it }.toMap().toMutableMap()
            invLast.first.forEach {
                if (totalInv.containsKey(it.agent_id to it.product_id)) {
                    val cur = totalInv[it.agent_id to it.product_id]!!


                    totalInv[Pair(it.agent_id, it.product_id)] = cur.copy(
                        valueSum = cur.valueSum + it.valueSum,
                        valueSumSec = cur.valueSumSec + it.valueSumSec,
                        returnSum = cur.returnSum + it.returnSum,
                        returnSumSec = cur.returnSumSec + it.returnSumSec
                    )
                } else {
                    totalInv[it.agent_id to it.product_id] = it
                }

            }

            var inNewInventory: MutableList<InventoryItem> = mutableListOf()
            var seen = mutableListOf<Pair<Int, Int>>()
            data.groupBy { it.agent_id }.forEach {
                val agent = it.key
                val info = it.value

                info.forEach {
                    val x = totalInv[Pair(it.agent_id, it.product_id)]
                    seen.add(Pair(it.agent_id, it.product_id))
                    val invV = InventoryItem(
                        agent_id = agent,
                        date = params["date"] as String,
                        product_id = it.product_id,
                        type = 0,
                        inv_type = 1,
                        returnSum = 0f,
                        returnSumSec = 0f,
                        updated = DatesManipulator.dateNow(),
                        valueSum = (it.inventoryStart ?: 0f) - (x?.valueSum ?: 0f),
                        valueSumSec = (it.inventoryStart2 ?: 0f) - (x?.valueSumSec ?: 0f)
                    )
                    inNewInventory.add(invV)

                }

            }
            if (type == 2) {
                val agents = data.groupBy { it.agent_id }.keys
                totalInv.values.forEach {
                    if (agents.contains(it.agent_id) && !seen.contains(Pair(it.agent_id, it.product_id))) {
                        val invV = InventoryItem(
                            agent_id = it.agent_id,
                            date = params["date"] as String,
                            product_id = it.product_id,
                            type = 0,
                            inv_type = 1,
                            returnSum = 0f,
                            returnSumSec = 0f,
                            updated = DatesManipulator.dateNow(),
                            valueSum = -it.valueSum,
                            valueSumSec = -it.valueSumSec
                        )
                        inNewInventory.add(invV)
                    }
                }
            }


            val q = insertInventory(date = params["date"] as String, inNewInventory)
            if (q != DBQuery.SUCCESS) {
                return q
            }
            return DBQuery.SUCCESS
        }

        val agent_ids = data.map { it.agent_id }.distinct()
        val exist = buildClientOrderNotes(
            client_id = -1,
            fromDate = params["date"] as String,
            toDate = params["date"] as String,
            agent_id = agent_ids
        )
        if (exist.second != DBQuery.SUCCESS) {
            return exist.second
        }
        val order = exist.first.mapNotNull { it.agent_id to it }.toMap()
        data.groupBy { it.agent_id }.forEach {
            val agent = it.key
            val info = it.value
            val order_info = order[agent]
            val changes = info.map {
                ProductDelivery(
                    it.product_id,
                    it.inventoryStart ?: 0f,
                    0f,
                    0f,
                    wrapped_amount = it.inventoryStart2 ?: 0f,
                    conversion_ratio = getClientProduct(it.product_id).first?.getOrderProduct()?.conversion_rate ?: 0f,
                )
            }

            val pd = changes


//            val pd = if (order_info == null) {
//                changes
//            } else {
//                val cur = changes.map { it.productId to it }.toMap().toMutableMap()
//                order_info.delivery_info.forEach {
//                    if (!cur.containsKey(it.productId)) {
//                        cur[it.productId] = it
//                    }
//                }
//                cur.values.toList()
//            }
            val q = newClientOrderNote(
                agent = params["agent"]!! as String,
                ent_id = -1,
                date = params["date"]!! as String,
                date_issued = DatesManipulator.dateNow(),
                delivery_value = pd,
                sup_delivery_value = emptyList(),
                active = 1,
                agent_id = agent
            ).second
            if (q != DBQuery.SUCCESS) {
                return q
            }

        }
        return DBQuery.SUCCESS
    }

    suspend fun newClientOrderNote(
        params: HashMap<String, Any>
    ): Respone<OrderNote?, DBQuery> {
        return this.newClientOrderNote(
            agent = params["agent"]!! as String,
            ent_id = params["ent_id"]!! as Int,
            date = params["date"]!! as String,
            date_issued = params["date_issued"]!! as String,
            delivery_value = params["delivery_value"]!! as List<ProductDelivery>,
            sup_delivery_value = params["sup_delivery_value"]!! as List<ProductDelivery>,
            active = (params["status"] as Int?) ?: 1,
            notes = params["notes"] as String?,
            category = params["category"] as String?,
            agent_id = params["agent_id"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            notes6 = params["notes6"] as String?,
            notes7 = params["notes7"] as String?,
            notes8 = params["notes8"] as String?,
            notes9 = params["notes9"] as String?,
            notes10 = params["notes10"] as String?,
            with_price = (params["new_price"] as Boolean?) ?: (params["with_price"] as Boolean?) ?: false,
            collection = params["collection"] as Map<Int, CollectionObject>?,
            checkUpdate = (params["checkUpdate"] as Boolean?) ?: false,
            static_data = params["static_data"] as ClientStaticData?,
            delivery_date = params["delivery_date"] as String?,
            force_position = params["force_position"] as Int?,
            notify = (params["notify"] as? Boolean) == true,
            )
    }

    suspend fun updateClientOrderNote(
        params: HashMap<String, Any>
    ): Respone<OrderNote?, DBQuery> {
        var status = (params["status"] as String?)?.let {
            OrderStatus.REGULAR.inverseName(it).state
        }
        return this.updateClientOrderNote(
            order_id = params["order_id"]!! as Int,
            agent = params["agent"] as String?,
            active = status ?: params["active"] as Int?,
            date = params["date"] as String?,
            delivery_value = params["delivery_value"] as List<ProductDelivery>?,
            sup_delivery_value = params["sup_delivery_value"] as List<ProductDelivery>?,
            notes = params["notes"] as String?,
            category = params["category"] as String?,
            updatePrice = (params["updatePrice"] as Boolean?) ?: false,
            agent_id = params["agent_id"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            notes6 = params["notes6"] as String?,
            notes7 = params["notes7"] as String?,
            notes8 = params["notes8"] as String?,
            notes9 = params["notes9"] as String?,
            notes10 = params["notes10"] as String?,

            collection = params["collection"] as Map<Int, CollectionObject>?,
            collector_id = params["collector_id"] as Int?,
            karton = params["karton"] as Float?,
            update_agent = params["update_agent"] as String?,
            static_data = params["static_data"] as ClientStaticData?,
            e_agent = params["e_agent"] as String?,
            inventory = (params["inventory"] as String?),
            delivery_date = params["delivery_date"] as String?,
            force_position = params["force_position"] as Int?,
            notify = (params["notify"] as? Boolean) == true,
        )
    }

    suspend fun buildClientMonthlyCycle(
        params: HashMap<String, Any>
    ): Respone<List<MonthlyCycle>, DBQuery> {
        return this.buildClientMonthlyCycle(
            date = params["date"] as String?, id = params["id"] as Int?, full = params["full"] as Boolean? ?: false
        )
    }

    suspend fun buildClientMonthlyCyclePdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.buildClientMonthlyCyclePdf(
            client_name = (params["client_name"] as String),
            month = params["month"] as String,
            year = params["year"] as String
        )

    }

    suspend fun buildClientDeliveryNotePdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.buildClientDeliveryNotePdf(
            id = params["id"] as Int, origin = params["origin"] as Int, force_price = params["force_price"] as Boolean?
        )
    }

    suspend fun buildClientCartesetPdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        val supFlag = when (val v = params["sup"]) {
            is Boolean -> v
            is Int -> v != 0
            is String -> v.equals("true", ignoreCase = true)
            else -> false
        }
        val showCancel = when (val v = params["show_cancel"]) {
            is Boolean -> v
            is Int -> v != 0
            is String -> v == "1" || v.equals("true", ignoreCase = true)
            else -> false
        }
        return this.buildClientCartesetPdf(
            id = params["id"] as Int,
            dates = params["dates"] as String,
            onlyTaxSide = params["onlyTaxSide"] as Boolean?,
            open = params["open"] as Boolean?,
            pdf_output_mode = params["pdf_output_mode"] as? String,
            sup = supFlag,
            showCancel = showCancel,
        )
    }

    suspend fun buildClientOrderPdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.calcClientOrderPdf(
            ids = params["ids"] as List<Int>, cofc = (params["cofc"] as Boolean?)
                ?: false, id = params["id"] as Int?,
            pdf_output_mode = params["pdf_output_mode"] as? String,
        )
    }

    suspend fun buildClientMASSdocPdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        val supFlag = when (val v = params["sup"]) {
            is Boolean -> v
            is Int -> v != 0
            is String -> v.equals("true", ignoreCase = true)
            else -> false
        }
        val onlyDebtFlag = when (val v = params["only_debt"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v == "1" || v.equals("true", ignoreCase = true)
            else -> false
        }
        val collectionFlag = when (val v = params["collection"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v == "1" || v.equals("true", ignoreCase = true)
            else -> false
        }
        val zipFlag = when (val v = params["zip"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v == "1" || v.equals("true", ignoreCase = true)
            else -> false
        }
        val photosFlag = when (val v = params["photos"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v == "1" || v.equals("true", ignoreCase = true)
            else -> false
        }
        return this.calcMASSdocPdf(
            ids = params["ids"] as List<Int>,
            docs = params["docs"] as List<Int>,
            force_price = params["force_price"] as Boolean?,
            origin = when (val v = params["origin"]) {
                is Boolean -> v
                is Number -> v.toInt() == 1
                is String -> v == "1" || v.equals("true", ignoreCase = true)
                else -> null
            },
            // 0 must stay 0 (העתק). `as Int?` is fine, but Number/String boxing must not drop it.
            originForce = when (val v = params["originForce"]) {
                is Number -> v.toInt()
                is String -> v.toIntOrNull()
                is Boolean -> if (v) 1 else 0
                else -> null
            },
            dates = params["dates"] as String?,
            price_value = params["price_value"] as Int?,
            pdf_output_mode = params["pdf_output_mode"] as? String,
            sup = supFlag,
            only_debt = onlyDebtFlag,
            collection = collectionFlag,
            zip = zipFlag,
            photos = photosFlag,
        )
    }

    suspend fun calcClientReportPdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.calcClientReportPdf(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            report_type = ReportType.valueOf(params["report_type"] as String),
            param = params["param"] as String?,
            pdf_output_mode = params["pdf_output_mode"] as? String,
        )
    }

    suspend fun buildClientPricesPdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.buildClientPricesPdf(
            id = params["id"] as Int, date = params["date"] as String, product_ids = params["p_ids"] as List<Int>?,
            pdf_output_mode = params["pdf_output_mode"] as? String,
            price_cols = params["price_cols"] as? String,
        )
    }

    suspend fun buildClientTaxNoteCyclePdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.buildClientTaxNoteCyclePdf(
            client_name = (params["client_name"] as String),
            month = params["month"] as String,
            year = params["year"] as String,
            id = params["id"] as Int,
            type = params["type"] as Int,
            origin = params["origin"] as Int
        )
    }

    suspend fun buildClientPayCyclePdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        val supFlag = when (val v = params["sup"]) {
            is Boolean -> v
            is Int -> v != 0
            is String -> v.equals("true", ignoreCase = true)
            else -> false
        }
        return this.buildClientPayCyclePdf(
            client_name = (params["client_name"] as String),
            month = params["month"] as String,
            year = params["year"] as String,
            id = params["id"] as Int,
            origin = params["origin"] as Int,
            sup = supFlag
        )

    }

    suspend fun calcClientDeliveryNotePdf(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        val client_ids = params["client_ids"] as List<Int>?
        return this.calcClientDeliveryNotePdf(
            client_id = params["client_id"] as Int,
            date_range = params["date_range"] as String,
            specific_notes = params["specific_notes"] as String?,
            tax_id_merge = params["tax_id_merge"] as List<Int>?,
            force_sum_type = params["force_sum_type"] as Int?,
            client_ids = client_ids,
            withPrices = (params["withPrices"] as Int?),
            pdf_output_mode = params["pdf_output_mode"] as? String,
        )
    }

    suspend fun calcMonthlyAccountAllPdf(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        val ids = when (val v = params["ids"] ?: params["client_ids"]) {
            is List<*> -> v.mapNotNull { (it as? Number)?.toInt() }
            is String -> v.split(",").mapNotNull { it.trim().toIntOrNull() }
            is Number -> listOf(v.toInt())
            else -> null
        }
        val mergeDates = when (val v = params["merge_dates"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v.isNotBlank() && !v.equals("0", ignoreCase = true) && !v.equals("false", ignoreCase = true)
            else -> false
        }
        val withBarcode = when (val v = params["with_barcode"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v.isNotBlank() && !v.equals("0", ignoreCase = true) && !v.equals("false", ignoreCase = true)
            else -> false
        }
        return this.calcMonthlyAccountAllPdf(
            date_range = params["date_range"] as String,
            client_ids = ids,
            merge_dates = mergeDates,
            with_barcode = withBarcode,
            products_per_page = (params["products_per_page"] as? Number)?.toInt(),
            pdf_output_mode = params["pdf_output_mode"] as? String,
        )
    }

    suspend fun calcClientDeliveryNotePdfEasy(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        val docs = params["ids"] as List<Int>
        val order = (params["order"] as Boolean?)
        val realDocs =
            if (order == true) getClientOrderNotes(order_ids = docs).first else getClientDeliveryNotes(docs).first
        val client_id = realDocs.first().ent_id
        val dates = DatesHolder(realDocs.map { it.date }.distinct())
        return this.calcClientDeliveryNotePdf(
            client_id = client_id,
            date_range = dates.toStringFirstLastRange(),
            specific_notes = docs.joinToString(","),
            tax_id_merge = params["tax_id_merge"] as List<Int>?,
            force_sum_type = params["force_sum_type"] as Int?,
            order = order,
            withPrices = (params["withPrices"] as Int?),
            pdf_output_mode = params["pdf_output_mode"] as? String,
        )
    }

    suspend fun calcClientDebtXSL(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcClientDebtXSL(
            date_range = params["date_range"] as String,
            agent = params["agent"] as Int,
            noZero = params["noZero"] as Int?
        )
    }

    suspend fun calcDocumentZip(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcDocumentZip(
            doc_type = params["doc_type"] as Int,
            date_range = params["date_range"] as String,
        )
    }

    suspend fun calcApiExcelZip(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcApiExcelZip(
            date_start = params["date_start"] as String,
            date_end = params["date_end"] as String,
            xlsxType = params["xlsxType"] as String?,
            c_ids = params["c_ids"] as List<Int>?,
            ids = params["ids"] as List<Int>?,
        )
    }

    suspend fun calcApiHashavshevetZip(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        fun intParam(key: String): Int? = (params[key] as? Number)?.toInt()
        return this.calcApiHashavshevetZip(
            date_start = params["date_start"] as String,
            date_end = params["date_end"] as String,
            ids = params["ids"] as List<Int>?,
            types = params["types"] as List<Int>?,
            last_invoice_id = intParam("last_invoice_id"),
            last_refund_id = intParam("last_refund_id"),
            last_invoice_payment_id = intParam("last_invoice_payment_id"),
            last_receipt_id = intParam("last_receipt_id"),
            last_deposit_id = intParam("last_deposit_id"),
        )
    }

    suspend fun setClientMonthlyCycle(
        params: HashMap<String, Any>
    ): Respone<MonthlyCycle?, DBQuery> {
        return this.setClientMonthlyCycle(
            date = params["date"]!! as String,
            id = params["id"]!! as Int,
            value = params["value"]!! as Float,
            paid = params["paid"] as Float?,
            date_paid = params["date_paid"] as String?,
            date_updated = params["date_updated"]!! as String
        )
    }


    suspend fun buildClientTaxNote(
        params: HashMap<String, Any>
    ): Respone<List<ClientTaxNote>, DBQuery> {
        return if (params.containsKey("last")) {
            val type = params["type"] as Int?
            if(type==10) {
                val ret1 = this.buildClientLastTaxNote(
                    client_id = params["client_id"] as Int?,
                    full = params["full"] as Boolean? ?: false,
                    type = 0,
                    client_ids = params["client_ids"] as List<Int>?,
                    sup = (params["sup"] as Boolean?) ?: false,
                    limit = params["limit"] as Int?,


                    )
                val ret2 =this.buildClientLastTaxNote(
                    client_id = params["client_id"] as Int?,
                    full = params["full"] as Boolean? ?: false,
                    type = 1,
                    client_ids = params["client_ids"] as List<Int>?,
                    sup = (params["sup"] as Boolean?) ?: false,
                    limit = params["limit"] as Int?,


                    )
                val combined = ret1.first + ret2.first
                 return Respone(combined, if (ret1.second == DBQuery.SUCCESS) ret2.second else ret1.second)
            }
            this.buildClientLastTaxNote(
                client_id = params["client_id"] as Int?,
                full = params["full"] as Boolean? ?: false,
                type = params["type"] as Int?,
                client_ids = params["client_ids"] as List<Int>?,
                sup = (params["sup"] as Boolean?) ?: false,
                limit = params["limit"] as Int?,


                )
        } else {
            val client_ids = (params["client_ids"] as List<Int>?) ?: (params["client_id"] as Int?)?.let {
                if((params["sup"] as Boolean?) ?: false) {
                    listOf(it)
                } else {
                    val branch = getClient(it).first?.branch
                    branch?.let { br ->
                        if (br != -1) getBranchMembers(br, false).first.map { it.id }
                        else listOf(it)
                    } ?: listOf(it)
                }


            }

            return this.buildClientTaxNote(
                client_ids = client_ids,
                id = params["id"] as Int?,
                ids = params["ids"] as List<Int>?,
                fromDate = params["fromDate"] as String?,
                toDate = params["toDate"] as String?,
                full = params["full"] as Boolean? ?: false,
                type = params["type"] as Int?,
                open = params["open"] as Boolean?,
                withProduct = params["withProduct"] as Int?,
                check_date = params["check_date"] as String?,
                order_ids = params["order_ids"] as List<Int>?,
                sup = (params["sup"] as Boolean?) ?: false,
            )
        }

    }

    suspend fun getClientGiulFast(params: HashMap<String, Any>): Respone<List<GlulStruct>, DBQuery> {
        return this.getClientGiul(
            toDate = params["toDate"] as String,
            date = params["date"] as String,
            shrinkNum = params["shrinkNum"] as Int? ?: 0,
        )
    }

    suspend fun getClientGiul(
        params: HashMap<String, Any>
    ): Respone<List<GlulStruct>?, DBQuery> {
        val tns = this.buildClientTaxNote(
            id = params["id"] as Int?,
            ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            full = params["full"] as Boolean? ?: false,
            open = true,
            sup = (params["sup"] as Boolean?) ?: false,
        )
        if (tns.second != DBQuery.SUCCESS) return Respone(null, tns.second)

        val method = params["method"] as Int // 1=regular, 2=2months, 3=3months, etc.
        val ret: MutableMap<Int, MutableList<Pair<Int, Float>>> = mutableMapOf()

        val groupedNotes = tns.first.groupBy { it.client_id }

        val lst = groupedNotes.map { (clientId, clientNotes) ->
            val sortedNotes = clientNotes.sortedBy { it.document_date }

            val valueSums = mutableListOf<Float?>()
            val openAmounts = mutableListOf<Int?>()

            val bucketNotes = mutableListOf<ClientTaxNote>()
            val restNotes = mutableListOf<ClientTaxNote>()

            if (method in 1..5) {
                val cutoff = sortedNotes.size - method
                bucketNotes.addAll(sortedNotes.takeLast(method))
                restNotes.addAll(sortedNotes.dropLast(method))
            } else {
                bucketNotes.addAll(sortedNotes)
            }

            // Calculate bucket values
            bucketNotes.forEachIndexed { index, note ->
                if (index < 4) {
                    valueSums.add(note.value_left)
                    openAmounts.add(1) // Assume each note contributes 1 to the open count
                }
            }

            // Fill in missing values for up to 4 buckets
            while (valueSums.size < 4) valueSums.add(null)
            while (openAmounts.size < 4) openAmounts.add(null)

            // Calculate totals for the rest
            val restTotalValueSum = restNotes.sumOf { it.value_left.toDouble() }
            val restNumOpen = restNotes.size

            GlulStruct(
                client_id = clientId,
                branch = 0,
                totalValueSum = bucketNotes.sumOf { it.value_left.toDouble() }.toFloat(),
                taxNotes = bucketNotes,
                numOfOpen = bucketNotes.size.toFloat(),
                valueSum1 = valueSums.getOrNull(0),
                openAmount1 = openAmounts.getOrNull(0),
                valueSum2 = valueSums.getOrNull(1),
                openAmount2 = openAmounts.getOrNull(1),
                valueSum3 = valueSums.getOrNull(2),
                openAmount3 = openAmounts.getOrNull(2),
                valueSum4 = valueSums.getOrNull(3),
                openAmount4 = openAmounts.getOrNull(3),
                restTotalValueSum = restTotalValueSum.toFloat(),
                restNumOpen = restNumOpen
            )
        }
        return Respone(lst, DBQuery.SUCCESS)
    }

    suspend fun newClientTaxNoteDVWithBranchSplit(
        params: HashMap<String, Any>
    ): Respone<List<String>, DBQuery> {
        return this.newClientTaxNoteDVWithBranchSplit(
            document_date = params["document_date"]!! as String,
            deliveryNotes = getClientDeliveryNotes(ids = params["delivery_notes"] as List<Int>).first,
            discount_percent = params["discount_percent"] as Float?,
            external_details = params["external_details"] as String?,
            agent_id = params["agent_id"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            agent = params["agent"] as String,
            doRound = (params["doRound"] as Boolean?) ?: false,
            splitBranch = (params["splitBranch"] as Boolean?) ?: false,
            increase_id = params["increase_id"] as Int?,
            allowZeroPrice = (params["allowZeroPrice"] as Boolean?) ?: false,
        )
    }

    suspend fun clearCartesert(params: HashMap<String, Any>): DBQuery {
        return this.clearCartesert(
            params["id"] as Int,
            params["date"] as String,
            sup = params["sup"] as Boolean? ?: false

        )
    }

    suspend fun newClientTaxNoteWithSplit(
        params: HashMap<String, Any>
    ): Respone<List<InformationBase>, DBQuery> {
        return this.newClientTaxNoteWithSplit(
            client_id = params["client_id"]!! as Int,
            date = params["date"]!! as String,
            document_date = params["document_date"]!! as String,
            delivery_value = params["delivery_info"]!! as List<ProductDelivery>,
            details = params["details"] as ClientStaticData,
            discount_percent = params["discount_percent"] as Float?,
            type = params["type"]!! as Int,
            with_price = params["with_price"] as Boolean? ?: false,
            external_details = params["external_details"] as String?,
            agent = params["agent"] as String,
            fastPay = params["fastPay"] as List<PaymentData>?,
            round = params["round"] as Boolean,
            order_id = params["order_id"] as Int?,
            agent_id = params["agent_id"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            increase_id = params["increase_id"] as Int?,
            sup = params["sup"] as Boolean? ?: false,
        )
    }

    suspend fun newClientTaxNote(
        params: HashMap<String, Any>
    ): Respone<List<ClientTaxNote>, DBQuery> {

        val fromOrder = params["fromOrder"] as Boolean?
        var order_id = params["order_id"] as Int?
        val d = params["dataValues"]!! as List<ClientTaxNoteData>
        if (order_id == null && fromOrder == true) {
            val pr = ClientTaxNote.extractPds(d)

            val o = newClientOrderNote(
                agent = params["agent"]!! as String,
                ent_id = params["client_id"]!! as Int,
                date = params["document_date"]!! as String,
                date_issued = params["date"]!! as String,
                delivery_value = pr,
                sup_delivery_value = listOf(),
                notes = params["notes"] as String?,
                notes2 = params["notes2"] as String?,
                notes3 = params["notes3"] as String?,
                notes4 = params["notes4"] as String?,
                notes5 = params["notes5"] as String?,
            )
            order_id = o.first?.id

        }

        return this.newClientTaxNote(
            client_id = params["client_id"]!! as Int,
            date = params["date"]!! as String,
            document_date = params["document_date"]!! as String,
            value = params["value"]!! as Float,
            total_value = params["total_value"]!! as Float,
            dataValues = params["dataValues"]!! as List<ClientTaxNoteData>,
            details = params["details"] as ClientStaticData,
            discount_percent = params["discount_percent"] as Float?,
            cover_dates = params["cover_dates"] as String?,
            paymentsData = params["paymentsData"]!! as List<PaymentData>,
            type = params["type"]!! as Int,
            extra_delivery_notes_meta = params["extra_notes"] as List<Int>?,
            with_price = params["with_price"] as Boolean? ?: false,
            delivery_notes = params["delivery_notes"] as List<DeliveryNote>?,
            external_details = params["external_details"] as String?,
            agent = params["agent"] as String?,
            order_id = order_id,
            tax_note_id = params["tax_note_id"] as Int?,
            agent_id = params["agent_id"] as Int?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            increase_id = params["increase_id"] as Int?,
            taxConfirmation = params["taxConfirmation"] as String?,
            supplier_invoice_number = params["supplier_invoice_number"] as String?,
            sup = (params["sup"] as Boolean?) ?: false,


            )
    }

    suspend fun cancelClientTaxNote(
        params: HashMap<String, Any>
    ): Respone<ClientTaxNote?, DBQuery> {
        return this.cancelClientTaxNote(
            id = params["id"]!! as Int,
            type = params["type"]!! as Int,
            date = params["date"]!! as String,
            agent = (params["agent"] as String?) ?: "",
            increase_id = params["increase_id"] as Int?,
            sup = (params["sup"] as Boolean?) ?: false,
        )
    }

    suspend fun buildClientCheck(
        params: HashMap<String, Any>
    ): Respone<List<PaymentData>, DBQuery> {
        return buildClientChecks(
            client_id = params["client_id"] as Int?,
            client_ids = params["client_ids"] as List<Int>?,
            last = params["last"] as Int?,
            sup = (params["sup"] as Boolean?) ?: false,
        )

    }

    suspend fun buildClientOpenPays(
        params: HashMap<String, Any>
    ): Respone<List<InformationBase>, DBQuery> {
        return buildClientOpenPays(

            client_ids = params["client_ids"] as List<Int>?,
            sup = (params["sup"] as Boolean?) ?: false,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            full = params["full"] as Boolean? ?: false,
            paid = params["paid"] as Boolean??,
            dateIsDoc = params["dateIsDoc"] as Boolean? ?: false,
            paid_date_to = params["paid_date_to"] as String?,
            paid_date_from = params["paid_date_from"] as String?,
            check_number = params["check_number"] as String?,

            )

    }

    suspend fun buildClientPay(
        params: HashMap<String, Any>
    ): Respone<List<ClientPay>, DBQuery> {
        return if (params.containsKey("last")) {
            this.buildClientLastPay(
                client_id = params["client_id"] as Int?,
                full = params["full"] as Boolean? ?: false,
                client_ids = params["client_ids"] as List<Int>?,
                sup = (params["sup"] as Boolean?) ?: false,
                limit = params["limit"] as Int?,
            )
        } else {
            val client_ids = (params["client_ids"] as List<Int>?) ?: (params["client_id"] as Int?)?.let {
                val branch = getClient(it).first?.branch
                branch?.let { br ->
                    if (br != -1) getBranchMembers(br).first.map { it.id }
                    else listOf(it)
                } ?: listOf(it)

            }
            return this.buildClientPay(
                id = params["id"] as Int?,
                fromDate = params["fromDate"] as String?,
                toDate = params["toDate"] as String?,
                full = params["full"] as Boolean? ?: false,
                client_ids = client_ids,
                check_date = params["check_date"] as String?,
                sup = (params["sup"] as Boolean?) ?: false,
                check_number = params["check_number"] as String?,
            )
        }

    }

    suspend fun newClientPay(
        params: HashMap<String, Any>
    ): Respone<ClientPay?, DBQuery> {
        return this.newClientPay(
            client_id = params["client_id"]!! as Int,
            date = params["date"]!! as String,
            document_date = params["document_date"]!! as String,
            value = params["value"]!! as Float,
            details = params["details"] as ClientStaticData,
            paymentsData = params["paymentsData"]!! as List<PaymentData>,
            tax_note_id = params["tax_note_id"] as String?,
            cancel_id = params["cancel_id"] as Int?,
            external_details = params["external_details"] as String?,
            agent = params["agent"] as String?,
            refundRest = (params["refundRest"] as Boolean?),
            type = 0,
            increase_id = params["increase_id"] as Int?,
            sup = (params["sup"] as Boolean?)?.let { if (it) 1 else 0 } ?: 0,
            ref_id = params["ref_id"] as String?,

            )
    }

    suspend fun updateClientPay(
        params: HashMap<String, Any>
    ): Respone<ClientPay?, DBQuery> {
        return this.updateClientPay(
            id = params["id"]!! as Int,
            paymentsData = params["paymentsData"] as List<PaymentData>?,
            tax_note_id = params["tax_note_id"] as String?,
            cancel_id = params["cancel_id"] as Int?,
            reopen_tax_notes = params["reopen_tax_notes"] as String?,
            active = params["active"] as Int?,
            external_details = params["external_details"] as String?,
            sup = (params["sup"] as Boolean?) ?: false,
            document_date = params["document_date"] as String?,
        )
    }

    suspend fun closePayment(
        params: HashMap<String, Any>
    ): Respone<InformationBase?, DBQuery> {
        val id = params["id"]!! as Int
        val type = params["type"]!! as Int
        val method = params["method"]!! as Int
        val details = params["details"] as String?
        val value = params["value"] as Float
        val checkNumber = (params["check_number"] as String?) ?: ""
        val bank_id = params["bank_id"] as String? ?: ""
        val clear = params["clear"] as Boolean? ?: false
        val sup = (params["sup"] as Boolean?) ?: false
        val paid_date = (params["paid_date"] as String?)?.let {
            val dd = it!!.split(" ")
            val datep = dd[0].split("-")
            if (datep.size == 3 && datep[2].length == 4) {
                "${datep[2]}-${datep[1]}-${datep[0]}"
            } else it.replace("/", "-")

        }
        val notes = params["notes"] as String?
        val category = params["category"] as String?
        val pay = when (type) {
            1 -> getClientTaxNote(
                id = id,
                type = 1, sup = sup
            ).first.firstOrNull()

            else -> getClientPay(id = id, sup = sup).first.firstOrNull()
        }


        if (pay != null) {
            val payments = if (type == 7) (pay as ClientPay).paymentsData else (pay as ClientTaxNote).paymentsData
            val ind = if (paid_date != null)
                payments.indexOfFirst { it.payMethod.state == method && (((bank_id == it.bank_id && it.check_number == checkNumber) || (it.pay_method == 1)) && it.value == value && it.paid != null && it.paid == 1) }
            else
                payments.indexOfFirst { it.payMethod.state == method && (((bank_id == it.bank_id && it.check_number == checkNumber) || (it.pay_method == 1)) && it.value == value && ((clear && it.paid != null && it.paid == 1) || (!clear && it.paid == null || it.paid == 0))) }
            if (ind != -1) {
                val cur_payments = payments.mapIndexed { index: Int, paymentData: PaymentData ->
                    if (index == ind) {
                        paymentData.copy(
                            paid = if (clear) 0 else 1,
                            paid_date = if (clear) null else paid_date ?: DatesManipulator.dateNow(),
                            paid_details = details,
                            notes = notes,
                            category = category
                        )
                    } else
                        paymentData
                }
                return when {
                    type == 1 && !sup -> this.updateClientTaxNotePay(
                        id = params["id"]!! as Int,
                        paymentsData = cur_payments,
                    ) as Respone<InformationBase?, DBQuery>

                    type == 1 && sup -> this.updateClientTaxNotePay(
                        id = params["id"]!! as Int,
                        paymentsData = cur_payments,
                        sup = true
                    ) as Respone<InformationBase?, DBQuery>

                    type == 7 && sup -> this.updateClientPay(
                        id = params["id"]!! as Int,
                        paymentsData = cur_payments,
                        sup = true
                    ) as Respone<InformationBase?, DBQuery>

                    else -> this.updateClientPay(
                        id = params["id"]!! as Int,
                        paymentsData = cur_payments,
                    ) as Respone<InformationBase?, DBQuery>
                }

            }

        }

        return Respone(null, DBQuery.FAILED)


    }

    suspend fun cancelClientPay(
        params: HashMap<String, Any>
    ): Respone<ClientPay?, DBQuery> {
        return this.cancelClientPay(
            id = params["id"]!! as Int,
            date = params["date"]!! as String,
            agent = (params["agent"] as String?)
                ?: "",
            increase_id = params["increase_id"] as Int?,
            value = params["value"] as Float?,
            checkNumber = params["check_number"] as String?,
            bank_id = params["bank_id"] as String?,
            method = params["method"] as Int?,
            sup = (params["sup"] as Boolean?) ?: false,
        )
    }

    suspend fun deActivate(params: HashMap<String, Any>): DBQuery {
        when {
            (params["type"]!! as String).compareTo("client") == 0 -> {
                return deActivate(params["value"]!! as Client)
            }

            (params["type"]!! as String).compareTo("delivery") == 0 -> {
                return deActivate(
                    (params["entity"]!! as String),
                    params["value"]!! as DeliveryNote,
                    state = (params["state"] as Int?) ?: 1
                ).second
            }

            (params["type"]!! as String).compareTo("product") == 0 -> {
                return deActivate((params["entity"]!! as String), params["value"]!! as Product)
            }

            (params["type"]!! as String).compareTo("supplier") == 0 -> {
                return deActivate(params["value"]!! as Supplier)
            }
        }
        return DBQuery.FAILED
    }

    suspend fun activate(params: HashMap<String, Any>): DBQuery {
        when {
            (params["type"]!! as String).compareTo("client") == 0 -> {
                return activate(params["value"]!! as Client)
            }

            (params["type"]!! as String).compareTo("delivery") == 0 -> {
                return activate((params["entity"]!! as String), params["value"]!! as DeliveryNote)
            }

            (params["type"]!! as String).compareTo("product") == 0 -> {
                return activate((params["entity"]!! as String), params["value"]!! as Product)
            }

            (params["type"]!! as String).compareTo("supplier") == 0 -> {
                return activate(params["value"]!! as Supplier)
            }
        }
        return DBQuery.FAILED
    }


    suspend fun newSupplier(
        params: HashMap<String, Any>
    ): Respone<Supplier?, DBQuery> {
        return this.newSupplier(
            name = params["name"]!! as String,
            date = params["date"]!! as String,
            include_tax = params["include_tax"] as Int?,
            business_name = params["business_name"] as String?,
            business_id = params["business_id"] as String?,
            address = params["address"] as String?,
            print_state = params["print_state"] as Int?,
            phone = params["phone"] as String?,
            phone_contact = params["phone_contact"] as String?,
            no_tax_client = params["no_tax_client"] as Int?,
            external_id = params["external_id"] as String?,
            comments = params["comments"] as String?,
            category = params["category"] as String?,
            payment_notes = params["payment_notes"] as String?,
            category2 = params["category2"] as String?,
        )
    }

    suspend fun updateSupplier(
        params: HashMap<String, Any>
    ): Respone<Supplier?, DBQuery> {
        return this.updateSupplier(
            id = params["id"]!! as Int,
            date = params["date"]!! as String,
            name = params["name"] as String?,
            include_tax = params["include_tax"] as Int?,
            business_name = params["business_name"] as String?,
            business_id = params["business_id"] as String?,
            address = params["address"] as String?,
            print_state = params["print_state"] as Int?,
            position = params["position"] as Int?,
            active = params["active"] as Int?,
            phone = params["phone"] as String?,
            no_tax_client = params["no_tax_client"] as Int?,
            external_id = params["external_id"] as String?,
            comments = params["comments"] as String?,
            category = params["category"] as String?,
            payment_notes = params["payment_notes"] as String?,
            category2 = params["category2"] as String?,
            phone_contact = params["phone_contact"] as String?,
        )
    }


    /** Unit param from the web/mobile: a WrappedName id, a unit name, or "" for none. */
    private fun supplierUnitParam(value: Any?): Int? = when (value) {
        null -> null
        is Number -> value.toInt().coerceAtLeast(0)
        is String -> if (value.isBlank()) 0 else value.trim().toIntOrNull()
            ?: WrappedName.convertFrom(value.trim())?.state ?: 0
        else -> null
    }

    private fun supplierRateParam(value: Any?): Float? = when (value) {
        null -> null
        is Number -> value.toFloat().coerceAtLeast(0f)
        is String -> value.trim().toFloatOrNull()?.coerceAtLeast(0f) ?: 0f
        else -> null
    }

    suspend fun newSupplierProduct(
        params: HashMap<String, Any>
    ): Respone<Product?, DBQuery> {
        return this.newSupplierProduct(
            name = params["name"]!! as String,
            date = params["date"]!! as String,
            barcode = params["barcode"] as String?,
            default_price = params["default_price"] as Float?,
            connected_product = params["connected_product"] as Int?,
            no_tax_product = params["no_tax_product"] as Int?,
            category = params["category"] as String?,
            category2 = params["category2"] as String?,
            external_id = params["external_id"] as String?,
            unit = supplierUnitParam(params["unit"]),
            extra_unit = supplierUnitParam(params["extra_unit"]),
            conversion_rate = supplierRateParam(params["conversion_rate"]),
            third_unit = supplierUnitParam(params["third_unit"]),
            unit_preferece = (params["unit_preferece"] as Number?)?.toInt(),
        )
    }

    suspend fun updateSupplierProduct(params: HashMap<String, Any>): Respone<Product?, DBQuery> {
        return this.updateSupplierProduct(
            id = params["id"]!! as Int,
            date = params["date"]!! as String,
            name = params["name"] as String?,
            barcode = params["barcode"] as String?,
            default_price = params["default_price"] as Float?,
            position = params["position"] as Int?,
            active = params["active"] as Int?,
            connected_product = params["connected_product"] as Int?,
            no_tax_product = params["no_tax_product"] as Int?,
            category = params["category"] as String?,
            category2 = params["category2"] as String?,
            external_id = params["external_id"] as String?,
            unit = supplierUnitParam(params["unit"]),
            extra_unit = supplierUnitParam(params["extra_unit"]),
            conversion_rate = supplierRateParam(params["conversion_rate"]),
            third_unit = supplierUnitParam(params["third_unit"]),
            unit_preferece = (params["unit_preferece"] as Number?)?.toInt(),
        )
    }


    suspend fun buildSupplierPrices(params: HashMap<String, Any>): Respone<List<RawPrice>, DBQuery> {
        return this.buildSupplierPrices(
            id = params["id"] as Int?,
            product_id = params["product_id"] as Int?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String
        )
    }


    suspend fun newSupplierPrice(
        params: HashMap<String, Any>
    ): Respone<RawPrice?, DBQuery> {
        return this.newSupplierPrice(
            id = params["id"]!! as Int,
            product_id = params["product_id"]!! as Int,
            price = params["price"]!! as Float,
            date = params["date"] as String?,
            discount = params["discount"] as Float? ?: 0f,
            toDate = params["toDate"] as String?,
        )
    }

    suspend fun buildSupplierNotes(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {
        return if (params.containsKey("last")) {
            this.buildSupplierLastNotes(
                supplier_id = params["supplier_id"] as Int, full = params["full"] as Boolean? ?: false

            )
        } else {
            val supplierId = (params["supplier_id"] as Int?)
                ?: if ((params["sup"] as Boolean?) == true) params["client_id"] as Int? else null
            this.buildSupplierNotes(
                supplier_id = supplierId,
                delivery_id = params["delivery_id"] as Int?,
                fromDate = params["fromDate"] as String?,
                toDate = params["toDate"] as String?,
                full = params["full"] as Boolean? ?: false,
                open = params["open"] as Boolean?
            )
        }
    }

    suspend fun closeSupplierNote(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {
        return this.closeSupplierDeliveryNote(
            delivery_ids = params["ids"] as List<Int>
        )
    }

    suspend fun updateSupplierNote(
        params: HashMap<String, Any>
    ): Respone<DeliveryNote?, DBQuery> {
        return this.updateSupplierDeliveryNote(
            delivery_id = params["id"] as Int,
            paid = params["paid"] as Int?,
            active = params["active"] as Int?,
            connected_id = params["connected_id"] as Long?,
            delivery_value = params["delivery_value"] as List<ProductDelivery>?,
            notes = params["notes"] as String?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
            date = params["date"] as String?,
        )
    }

    suspend fun newSupplierDeliveryNote(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {
        return this.newSupplierDeliveryNote(
            agent = params["agent"]!! as String,
            ent_id = params["ent_id"]!! as Int,
            date = params["date"]!! as String,
            date_issued = params["date_issued"]!! as String,
            delivery_value = params["delivery_value"]!! as List<ProductDelivery>,
            connected_id = params["connected_id"] as Long?,
            with_price = params["with_price"] as Boolean? ?: false,
            notes = params["notes"] as String?,
            notes2 = params["notes2"] as String?,
            notes3 = params["notes3"] as String?,
            notes4 = params["notes4"] as String?,
            notes5 = params["notes5"] as String?,
        )
    }

    suspend fun calcSupplierDeliveryNotePdf(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        val docs = params["ids"] as List<Int>?
        return if (docs != null) {
            val realDocs = getSupplierDeliveryNotes(delivery_ids = docs).first
            val client_id = realDocs.first().ent_id
            val dates = DatesHolder(realDocs.map { it.date }.distinct())
            this.calcSupplierDeliveryNotePdf(
                sup_id = client_id, date_range = dates.toStringFirstLastRange(), specific_notes = docs.joinToString(",")
            )
        } else {
            this.calcSupplierDeliveryNotePdf(
                sup_id = params["client_id"] as Int, date_range = params["date_range"] as String
            )
        }

    }

    suspend fun buildSupplierMonthlyCyclePdf(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.buildSupplierMonthlyCyclePdf(
            sup_name = (params["sup_name"] as String),
            month = params["month"] as String,
            year = params["year"] as String
        )

    }

    suspend fun buildSupplierMonthlyCycle(
        params: HashMap<String, Any>
    ): Respone<List<MonthlyCycle>, DBQuery> {
        return this.buildSupplierMonthlyCycle(
            date = params["date"] as String?, id = params["id"] as Int?, full = params["full"] as Boolean? ?: false
        )
    }

    suspend fun setSupplierMonthlyCycle(
        params: HashMap<String, Any>
    ): Respone<MonthlyCycle?, DBQuery> {
        return this.setSupplierMonthlyCycle(
            date = params["date"]!! as String,
            id = params["id"]!! as Int,
            value = params["value"]!! as Float,
            paid = params["paid"] as Float?,
            date_paid = params["date_paid"] as String?,
            date_updated = params["date_updated"]!! as String
        )

    }

    suspend fun buildTaklitProducts(
        params: HashMap<String, Any>
    ): Respone<List<TaklitProduct>, DBQuery> {
        return this.buildTaklitProducts(
            date = params["date"] as String, id = params["id"] as Int?
        )
    }

    suspend fun calcClientDebtTillNow(params: HashMap<String, Any>): DBQuery {
        return this.calcClientDebtTillNow(
            params["fromDate"] as String,
            params["toDate"] as String,
            params["id"] as Int?,
            withDebtYearly = (params["withDebtYearly"] as Boolean?) ?: false,
            cutoff = (params["cutoff"] as Boolean?) ?: false
        )
    }

    suspend fun calcSuptDebtTillNow(params: HashMap<String, Any>): DBQuery {
        return this.calcSuptDebtTillNow(
            params["fromDate"] as String,
            params["toDate"] as String,
            params["id"] as Int?,
            withDebtYearly = (params["withDebtYearly"] as Boolean?) ?: false
        )
    }

    suspend fun calcClientDebtTillNowWithMonthly(params: HashMap<String, Any>): DBQuery {
        val debt = this.calcOptimizedCartesetValue(
            ids = (params["id"] as Int?)?.let { listOf(it) },
            toDate = params["toDate"] as String,
        )
        val monthly = buildClientMonthlyCycle(params["date"] as String, id = params["id"] as Int?, full = true)
        if (debt != DBQuery.SUCCESS || monthly.second != DBQuery.SUCCESS)
            return DBQuery.FAILED
        if (params["open"] != null) {
            val open = this.queryData(
                fromDate = "2015-01-01",
                toDate = params["toDate"] as String,
                byMoney = true,
                paid = false,
                byEnt = listOf(-1)
            )
            if (open.second != DBQuery.SUCCESS)
                return DBQuery.FAILED
            val monthlyMap = mutableMapOf<Int, Float>()

            open.first?.forEach {
                if (it == null)
                    return@forEach
                val id = it.byEnt!!
                monthlyMap[id] = it.getTotalMoney()

            }
            val seen = mutableSetOf<Int>()
            monthly.first.forEach {
                val id = it.id
                it.openValue = monthlyMap[id] ?: 0f
                seen.add(id)
            }
            val newMonthly = mutableListOf<MonthlyCycle>()
            monthlyMap.forEach {
                if (!seen.contains(it.key))
                    newMonthly.add(
                        MonthlyCycle(
                            id = it.key,
                            value = 0f,
                            paid = 0f,
                            date = params["date"] as String,
                            openValue = it.value
                        )
                    )
            }
            _updateClientsMonthlyCycleMap(newMonthly)


        }

        return DBQuery.SUCCESS
    }


    suspend fun calcAmountData(params: HashMap<String, Any>): Respone<Triple<NotesAmountsQuery?, NotesAmountsQuery?, NotesAmountsQuery?>, DBQuery> {
        return this.calcAmountData(
            params["fromDate"] as String,
            params["toDate"] as String,
            params["advancer"] as StateNotifier?,
            params["id"] as Int?,
            (params["withAgent"] as Boolean?) ?: false,
            ids = params["ids"] as List<Int>?,
        )
    }

    suspend fun prepareMassTaxNote(params: HashMap<String, Any>): Respone<List<TaxNoteMassHolder>, DBQuery> {
        return this.prepareMassTaxNote(
            params["date"] as String,
            client_ids = (params["client_ids"] as List<Int>?)
                ?: ((params["client_id"] as Int?)?.let { listOf(it) }),
            fromDate = params["fromDate"] as String?,
            allOpen = (params["allOpen"] as Boolean?) ?: false
        )
    }

    suspend fun calcDocumentSum(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcDocumentSum(
            params["doc_type"] as Int,
            params["date_range"] as String,
            (params["pdf"] as Boolean?) ?: false,
            active_only = params["active_only"] as Boolean?,
            open_only = params["open_only"] as Boolean?,
            ent_id = params["ent_id"] as List<Int>?,
            pdf_output_mode = params["pdf_output_mode"] as? String,
        )
    }

    suspend fun calcDataToAccountManager(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.dataToAccountManager(
            params["date_range"] as String,
            forceType = (params["forceType"] as Int?)
        )
    }

    suspend fun calcOrderAmountData(params: HashMap<String, Any>): Respone<Pair<NotesAmountsQuery?, NotesAmountsQuery?>, DBQuery> {
        return this.calcOrdersAmountData(
            params["fromDate"] as String,
            params["toDate"] as String,
            params["advancer"] as StateNotifier?,
            (params["withAgent"] as Boolean?) ?: false
        )
    }

    suspend fun duplicateTomorowsOrder(params: HashMap<String, Any>): DBQuery {
        fun flag(key: String, default: Boolean = true): Boolean {
            val v = params[key] ?: return default
            return when (v) {
                is Boolean -> v
                is Number -> v.toInt() != 0
                else -> {
                    val s = v.toString().trim().lowercase()
                    s != "0" && s != "false" && s != "no"
                }
            }
        }
        return this.duplicateTomorowsOrder(
            date = params["date"] as String,
            toDate = params["toDate"] as String?,
            duplicateOrders = flag("orders", true),
            duplicateNotes = flag("notes", false),
        )
    }

    companion object {
        lateinit var activeDB: UINKDBInterface
    }

    suspend fun buildOrderProducts(
        params: HashMap<String, Any>
    ): Respone<List<OrderProduct>, DBQuery> {
        return this.buildOrderProducts(
            id = params["id"] as Int?,
            product_id = params["product_id"] as Int?,
            available = params["available"] as Boolean?,
            active = params["active"] as Boolean?,
        )
    }

    suspend fun newOrderProducts(
        params: HashMap<String, Any>
    ): Respone<OrderProduct?, DBQuery> {
        return this.newOrderProducts(
            id = params["id"] as Int,
            product_id = params["product_id"] as Int,
            extra_unit = params["extra_unit"] as Int,
            conversion_rate = params["conversion_rate"] as Float,
            available = params["available"] as Boolean,
            active = params["active"] as Boolean,
            weight = params["weight"] as Float,
            volume = params["volume"] as Float,
            englishName = params["englishName"] as String,
            orderName = params["orderName"] as String?,
            position = params["position"] as Int?,
            sales = params["sales"] as Int?,
            forceLock = params["forceLock"] as Int?,
            hourLock = params["hourLock"] as String?,
            dayLock = params["dayLock"] as Int?,
            step = params["step"] as Float?,
            collector = params["collector"] as Int?,
            min_order = params["min_order"] as Float?,
            unit_preferece = params["unit_preferece"] as Int?,
            armor = params["armor"] as Float?,
            days_ahead = params["days_ahead"] as Int?,
            third_unit = (params["third_unit"] as Int?) ?: 0,
            day_hour_locks = params["day_hour_locks"] as String?,
            delivery_cutoff_rules = params["delivery_cutoff_rules"] as String?,

            )
    }


    suspend fun buildCofcClients(
        params: HashMap<String, Any>
    ): Respone<List<Client>, DBQuery> {
        return this.buildCofcClients(
            id = params["id"] as Int,
            date = params["date"] as String,
        )
    }

    suspend fun getCofcUser(
        params: HashMap<String, Any>
    ): Respone<User?, DBQuery> {
        return this.getCofcUser(
            id = params["id"] as Int
        )
    }


    suspend fun registerCofcId(
        params: HashMap<String, Any>
    ): Respone<String?, DBQuery> {
        return this.registerCofcId(
            id = params["id"] as Int,
            until = params["date"] as String,
            open_date = params["open_date"] as String?,
            short = params["short"] as Boolean?,
            force_date = params["force_date"] as Boolean? ?:false,
            returns= (params["returns"] as Boolean?) ?: false
        )
    }

    suspend fun getCofcLink(
        params: HashMap<String, Any>
    ): Respone<Triple<String?, Int, String?>?, DBQuery> {
        val link = this.registerCofcId(
            id = params["id"] as Int,
            until = params["date"] as String,
            open_date = params["open_date"] as String?,
            short = params["short"] as Boolean?
        )

        return Respone(Triple(link.first, params["id"] as Int, params["open_date"] as String?), link.second)
    }

    suspend fun getCofcProducts(
        params: HashMap<String, Any>
    ): Respone<List<Product>, DBQuery> {
        return this.getCofcProducts(
            id = params["id"] as Int,
            date = params["date"] as String,
        )
    }

    suspend fun buildProductImages(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.buildProductImages(
            id = params["id"] as Int,
            date = params["date"] as String,
            product_id = params["product_id"] as Int?,
        )
    }

    suspend fun getCofcOrderProducts(
        params: HashMap<String, Any>
    ): Respone<List<OrderProduct>, DBQuery> {
        return this.getCofcOrderProducts(
            id = params["id"] as Int,
            op_id = params["op_id"] as Int?,
            product_id = params["product_id"] as Int?,
            available = params["available"] as Boolean?,
            active = params["active"] as Boolean?,
        )
    }

    suspend fun getCofcRealImagesAvailable(
        params: HashMap<String, Any>
    ): Respone<List<Int>, DBQuery> {
        return this.getCofcRealImagesAvailable(
            id = params["id"] as Int
        )
    }

    suspend fun getCofcProductsImage(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.getCofcProductsImage(
            id = params["id"] as Int,
            product_id = params["product_id"] as Int,
            date = params["date"] as String,
        )
    }

    suspend fun getClientProductImg(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.getClientProductsImage(
            product_id = params["product_id"] as Int?
        )
    }

    suspend fun getClientCardImg(
        params: HashMap<String, Any>
    ): DBQuery {
        val raw = params["client_id"] ?: params["id"]
        val clientId = when (raw) {
            is Int -> raw
            is Number -> raw.toInt()
            is String -> raw.toIntOrNull()
            else -> null
        } ?: return DBQuery.FAILED
        return this.fetchClientCardImage(clientId)
    }

    suspend fun getCofcClientsPrices(
        params: HashMap<String, Any>
    ): Respone<List<RawPrice>, DBQuery> {
        return this.getCofcClientsPrices(
            id = params["id"] as Int,
            date = params["date"] as String,
        )
    }

    suspend fun getCofcClientsOrder(
        params: HashMap<String, Any>
    ): Respone<List<OrderNote>, DBQuery> {
        return this.getCofcClientsOrder(
            id = params["id"] as Int,
            dateFrom = params["dateFrom"] as String,
            dateTo = params["dateTo"] as String,
            status = params["status"] as Int?,
        )
    }

    suspend fun updateConfConf(
        params: HashMap<String, Any>
    ): Respone<CofcConf?, DBQuery> {
        val stringParams = mutableMapOf<String, String>()
        for ((k, v) in params) {
            if (v == null) continue
            stringParams[k] = when (v) {
                is Int -> v.toString()
                is String -> v
                is Boolean -> if (v) "1" else "0"
                is Float, is Double -> v.toString()
                else -> v.toString()
            }
        }
        return updateConfConfParams(stringParams)
    }

    suspend fun calcClientDeliveryNoteCategory(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {
        return this.calcClientDeliveryNoteCategory(
            date_range = params["date_range"] as String,
            category = params["category"] as String,
            byCost = params["by_cost"]?.toString(),
            categoryKind = params["category_kind"]?.toString(),
            )
    }

    suspend fun newCofcOrderComplex(params: HashMap<String, Any>): Respone<OrderNote?, DBQuery> {

        val agent = params["agent"]!! as String
        val ent_id = params["ent_id"]!! as Int
        val date = params["date"]!! as String
        val date_issued = params["date_issued"]!! as String
        val delivery_value = params["delivery_value"]!! as List<ProductDelivery>
        val sup_delivery_info = params["sup_delivery_info"]!! as List<ProductDelivery>
        val active = (params["active"]!! as Int?) ?: 1
        val notes = params["notes"] as String?
        val category = params["category"] as String?
        val order_id = params["order_id"] as Int? // need edit
        val static_data = params["static_data"] as ClientStaticData?

        val client = getClient(ent_id).first ?: return Respone(null, DBQuery.FAILED)
        val needLock = userCofcConf?.unlock_p == 1
        // When editing a semi_locked order (נבדקה etc.), products already in it should
        // not be moved to the next available date even if they become time-locked.
        // We also preserve the original quantities for locked products so the UI can't modify them.
        val semiLockedOriginalProducts: Map<Int, ProductDelivery>? = if (needLock && order_id != null) {
            val existingOrders = getCofcClientsOrder(ent_id, date, date).first
            val editOrder = existingOrders.firstOrNull { it.id == order_id }
            if (editOrder?.orderStatus?.semi_locked() == true) {
                editOrder.delivery_info.associateBy { it.productId }
            } else null
        } else null
        val semiLockedProductIds: Set<Int>? = semiLockedOriginalProducts?.keys

        val pr = delivery_value.map {
            if (!needLock)
                Triple(it, date, false)
            else {
                val isLocked = isProductLocked(it.productId, DatesManipulator.dateIsrael(date), true, 1)
                val nd = getNextSupplyDate(it.productId, DatesManipulator.dateIsrael(date), true, 1, client, false)
                val locked_by_note = it.o_locked == 1
                val protectedBySemiLock = semiLockedProductIds?.contains(it.productId) == true && isLocked
                if (!locked_by_note && !protectedBySemiLock && isLocked && nd != null) {
                    Triple(it, nd, false)
                } else if (protectedBySemiLock) {
                    val original = semiLockedOriginalProducts!![it.productId]!!
                    Triple(original, date, true)
                } else
                    Triple(it, date, false)
            }

        }
        var o: Respone<OrderNote?, DBQuery> = Respone(null, DBQuery.FAILED)
        var someO: Respone<OrderNote?, DBQuery> = Respone(null, DBQuery.FAILED)
        pr.groupBy { it.second }.forEach {
            val d = it.key
            val products = it.value.map {
                it.first.copy(o_locked = if (it.first.o_locked == 1 || it.second != date || it.third) 1 else 0)
            }


            val existingOrder = this.getCofcClientsOrder(ent_id, d, d).first
            if (it.key == date) {
                if (order_id != null) {
                    val ex = existingOrder.firstOrNull { it.id == order_id }
                    if (ex != null) {

                        o = this.updateCofcClientOrderNote(
                            order_id = order_id,
                            agent = agent,
                            ent_id = ent_id,
                            date = d,
                            delivery_value = products,
                            sup_delivery_info = sup_delivery_info,
                            active = active,
                            notes = notes,
                            category = category,
                            static_data = static_data,
                        )
                    } else {
                        return Respone(null, DBQuery.FAILED)
                    }


                } else {
                    val res = this.newCofcClientOrderNote(
                        agent = agent,
                        ent_id = ent_id,
                        date = d,
                        date_issued = date_issued,
                        delivery_value = products,
                        sup_delivery_info = sup_delivery_info,
                        active = active,
                        notes = notes,
                        category = category,
                        order_id = order_id,
                        static_data = static_data,

                        )
                    o = res


                }
            } else {
                var ex: OrderNote? = existingOrder.firstOrNull { it.category == "בסיס" } ?: existingOrder.firstOrNull()
                var exist = true
                var category: String = "לינק_שריון"
                var newProducts: MutableList<ProductDelivery> = mutableListOf()
                if (ex == null) {
                    exist = false
                    val b = baseOrderDaysToData.get(DatesManipulator.getDayOfWeekIsrael(d) + 1)
                    if (b != null) {
                        val existingOrder = this.getCofcClientsOrder(ent_id, b, b).first
                        ex = existingOrder.firstOrNull { it.category == "בסיס" }
                        ex?.let {
                            category = "בסיס"
                        }

                    }
                    if (ex == null) {
                        val v = DatesManipulator.getNextDay(d, -7)
                        val existingOrder = this.getCofcClientsOrder(ent_id, v, v).first
                        ex = existingOrder.firstOrNull()
                    }


                }
                if (ex != null) {

                    newProducts.addAll(ex!!.delivery_info)
                    products.forEach {
                        val indexOfProduct = newProducts.indexOfFirst { p -> p.productId == it.productId }
                        if (indexOfProduct != -1 && newProducts[indexOfProduct].o_locked == 0) {
                            newProducts[indexOfProduct] = it

                        } else if (indexOfProduct == -1) {
                            newProducts.add(it.copy(o_locked = 1))
                        }
                    }
                } else {
                    newProducts.addAll(products)
                }
                newProducts =
                    newProducts.filter { it.getProduct().getOrderProduct()?.isAvailable() == true }.toMutableList()
                val res = if (exist) {
                    this.updateCofcClientOrderNote(
                        order_id = ex!!.id,
                        agent = ex!!.agent,
                        ent_id = ent_id,
                        date = d,
                        delivery_value = newProducts,
                        sup_delivery_info = sup_delivery_info,
                        active = ex!!.active,
                        notes = ex!!.notes,
                        category = ex!!.category,
                        static_data = ex!!.ClientStaticData,
                    )
                } else {
                    this.newCofcClientOrderNote(
                        agent = agent,
                        ent_id = ent_id,
                        date = d,
                        date_issued = date_issued,
                        delivery_value = newProducts,
                        sup_delivery_info = sup_delivery_info,
                        active = OrderStatus.DONE_BY_CLIENT.state,
                        notes = notes,
                        category = category,
                        order_id = order_id,
                        static_data = static_data,

                        )

                }
                someO = res

                if (res.second != DBQuery.SUCCESS)
                    return res
            }


        }
        if (o.first == null && order_id != null && pr.filter { it.second == date }.isEmpty()) {
            o = this.updateCofcClientOrderNote(
                order_id = order_id,
                agent = agent,
                ent_id = ent_id,
                date = date,
                delivery_value = listOf(),
                sup_delivery_info = sup_delivery_info,
                active = OrderStatus.REJECTED.state,
                notes = notes,
                category = category,
                static_data = static_data,
            )
        } else if (o.first == null) return someO
        return o

    }

    suspend fun newCofcClientOrderNote2(
        params: HashMap<String, Any>
    ): Respone<OrderNote?, DBQuery> {
        // Prefer ent_id; v2 also sends id/client_id (same value).
        val entId = (params["ent_id"] ?: params["client_id"] ?: params["id"]) as Int
        return this.newCofcClientOrderNote(
            agent = params["agent"]!! as String,
            ent_id = entId,
            date = params["date"]!! as String,
            date_issued = params["date_issued"]!! as String,
            delivery_value = params["delivery_value"]!! as List<ProductDelivery>,
            sup_delivery_info = params["sup_delivery_info"]!! as List<ProductDelivery>,
            active = (params["active"]!! as Int?) ?: 1,
            notes = params["notes"] as String?,
            category = params["category"] as String?,
            order_id = params["order_id"] as Int?,
            static_data = params["static_data"] as ClientStaticData?,
            agent_id = params["agent_id"] as Int?,
            returns_photo = params["returns_photo"] as ByteArray?

            )
    }

    suspend fun updateCofcClientOrderNote2(
        params: HashMap<String, Any>
    ): Respone<OrderNote?, DBQuery> {
        val entId = (params["ent_id"] ?: params["client_id"] ?: params["id"]) as Int
        return this.updateCofcClientOrderNote(
            order_id = params["order_id"]!! as Int,
            agent = params["agent"] as String?,
            ent_id = entId,
            date = params["date"]!! as String,
            delivery_value = params["delivery_value"]!! as List<ProductDelivery>,
            sup_delivery_info = params["sup_delivery_info"]!! as List<ProductDelivery>,
            active = (params["active"]!! as Int?) ?: 1,
            notes = params["notes"] as String?,
            category = params["category"] as String?,
            static_data = params["static_data"] as ClientStaticData?,
            agent_id = params["agent_id"] as Int?,
        )
    }

    suspend fun uploadImg(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.uploadImg(
            f = params["image"]!! as ByteArray, product_id = params["product_id"] as Int
        )
    }

    suspend fun uploadLogo(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.uploadLogo(
            f = params["image"]!! as ByteArray
        )
    }

    suspend fun uploadSign(
        params: HashMap<String, Any>
    ): Respone<NoteSignHolder?, DBQuery> {
        return this.uploadSign(
            f = params["image"]!! as ByteArray,
            note_id = params["note_id"]!! as Int,
            signer = params["signer"]!! as String,
            date = params["date"]!! as String,
            doc_type = params["doc_type"]!! as Int,
            offline = (params["offline"] as Boolean?) ?: false
        )
    }

    suspend fun uploadPhoto(
        params: HashMap<String, Any>
    ): Respone<NoteSignHolder?, DBQuery> {
        val indexRaw = params["index"]
        val index = when (indexRaw) {
            is Int -> indexRaw
            is Number -> indexRaw.toInt()
            is String -> indexRaw.toIntOrNull()
            else -> null
        }
        return this.uploadPhoto(
            f = params["image"]!! as ByteArray,
            note_id = params["note_id"]!! as Int,
            date = params["date"]!! as String,
            doc_type = params["doc_type"]!! as Int,
            offline = (params["offline"] as Boolean?) ?: false,
            index = index
        )
    }

    suspend fun deletePhoto(
        params: HashMap<String, Any>
    ): Respone<NoteSignHolder?, DBQuery> {
        val indexRaw = params["index"]
        val index = when (indexRaw) {
            is Int -> indexRaw
            is Number -> indexRaw.toInt()
            is String -> indexRaw.toIntOrNull() ?: 0
            else -> 0
        }
        return this.deletePhoto(
            note_id = params["note_id"]!! as Int,
            date = (params["date"] as String?) ?: DatesManipulator.dateNow(),
            doc_type = params["doc_type"]!! as Int,
            index = index,
            offline = (params["offline"] as Boolean?) ?: false
        )
    }

    suspend fun getSignImg(
        params: HashMap<String, Any>
    ): Respone<Triple<ByteArray?, Int, Int>, DBQuery> {
        return this.getSignImg(
            note_id = params["note_id"]!! as Int,
            doc_type = (params["doc_type"] as Int?) ?: 4,
            strict = (params["strict"] as Boolean?) ?: false
        )
    }

    suspend fun getSignPhoto(
        params: HashMap<String, Any>
    ): Respone<Triple<ByteArray?, Int, Int>, DBQuery> {
        return this.getSignPhoto(
            note_id = params["note_id"]!! as Int,
            doc_type = (params["doc_type"] as Int?) ?: 4,
            strict = (params["strict"] as Boolean?) ?: false
        )
    }

    suspend fun getSign(
        params: HashMap<String, Any>
    ): Respone<List<NoteSignHolder>, DBQuery> {
        return this.getSign(
            ids = params["note_ids"]!! as List<Int>,
            doc_type = (params["doc_type"] as Int?) ?: 4,
        )
    }

    suspend fun newClientCarteset(
        params: HashMap<String, Any>
    ): Respone<ClientCarteset?, DBQuery> {
        return this.newClientCarteset(
            client_id = params["id"]!! as Int,
            date = params["date"]!! as String,
            positive = params["positive"]!! as Float,
            negative = params["negative"]!! as Float,
            state = (params["state"] as Int?) ?: 0,
            notes = params["notes"] as String?,
            sup = (params["sup"] as Boolean?) ?: false,
        )
    }

    suspend fun newAllClientCarteset(
        params: HashMap<String, Any>
    ): Respone<List<ClientCarteset>, DBQuery> {
        return this.newAllClientCarteset(
            date = params["date"]!! as String,
            carteset = params["carteset"]!! as List<ClientCarteset>,
            sup = (params["sup"] as Boolean?) ?: false,
        )
    }

    suspend fun buildClientCartesetMap(
        params: HashMap<String, Any>
    ): Respone<List<ClientCarteset>, DBQuery> {
        return this.buildClientCartesetMap(
            id = params["id"] as Int?,
            fromDate = params["fromDate"]!! as String,
            toDate = params["toDate"]!! as String,
            state = (params["state"] as Int?),
            ids = params["ids"] as List<Int>?,
            sup = (params["sup"] as Boolean?) ?: false,
        )
    }


    suspend fun newClientProductApi(
        params: HashMap<String, Any>, update: Boolean = true
    ): Respone<Product?, DBQuery> {
        val id = params["product_id"] as Int?
        val product = if (id == null) {
            this.newClientProduct(
                name = params["name"]!! as String,
                date = params["date"]!! as String,
                barcode = params["barcode"] as String?,
                default_price = params["default_price"] as Float?,
                no_tax_product = params["no_tax_product"] as Int?,
                external_id = params["external_id"] as String?,
                unit = (params["unit"] as String?)?.let { WrappedName.convertFrom(it)?.state },
                unit_amount = params["unit_amount"] as Float?,
                category = params["category"] as String?,
                cost_price = params["cost_price"] as Float?,
                split_category = params["split_category"] as Int?,
                position = params["position"] as Int?,
                base_price = params["base_price"] as Float?,
                cost_include_returns = params["cost_include_returns"] as Int?,
                category2 = params["category2"] as String?,
                taklit_id = params["taklit_id"] as Int?,
                taklit_type = params["taklit_type"] as Int?,
                id = params["internal_id"] as Int?,
                p_range = params["p_range"] as Float?,
                notes2 = params["notes2"] as String?,
                notes3 = params["notes3"] as String?,
                notes4 = params["notes4"] as String?,
                notes5 = params["notes5"] as String?,
            )
        } else {
            if (update)
                this.updateClientProduct(
                    id = id,
                    name = params["name"] as String?,
                    date = params["date"]!! as String,
                    barcode = params["barcode"] as String?,
                    default_price = params["default_price"] as Float?,
                    no_tax_product = params["no_tax_product"] as Int?,
                    external_id = params["external_id"] as String?,
                    taklit_id = params["taklit_id"] as Int?,
                    taklit_type = params["taklit_type"] as Int?,
                    unit = (params["unit"] as String?)?.let { WrappedName.convertFrom(it)?.state },
                    unit_amount = params["unit_amount"] as Float?,
                    category = params["category"] as String?,
                    cost_price = params["cost_price"] as Float?,
                    split_category = params["split_category"] as Int?,
                    position = params["position"] as Int?,
                    base_price = params["base_price"] as Float?,
                    cost_include_returns = params["cost_include_returns"] as Int?,
                    active = (params["active"] as Boolean?)?.let { if (it) 1 else 0 },
                    category2 = params["category2"] as String?,
                    p_range = params["p_range"] as Float?,
                    notes2 = params["notes2"] as String?,
                    notes3 = params["notes3"] as String?,
                    notes4 = params["notes4"] as String?,
                    notes5 = params["notes5"] as String?,

                )
            else getClientProduct(id)
        }
        if (product.second != DBQuery.SUCCESS) {
            return product
        }
        val newOrderProduct = if (update) this.newOrderProducts(id = (params["order_product_id"] as Int?) ?: -1,
            product_id = product.first!!.id,
            extra_unit = (params["extra_unit"] as String?)?.let { WrappedName.convertFrom(it)?.state } ?: 0,
            conversion_rate = (params["conversion_rate"] as Float?) ?: 0f,
            available = (params["available"] as Boolean?) ?: true,
            active = true,
            weight = (params["weight"] as Float?),
            volume = (params["volume"] as Float?),
            englishName = (params["englishName"] as String?),
            orderName = (params["orderName"] as String?),
            sales = (params["sales"] as Int?) ?: 0,
            forceLock = (params["forceLock"] as Int?) ?: 0,
            hourLock = (params["hourLock"] as String?) ?: "",
            dayLock = (params["dayLock"] as Int?) ?: 127,
            step = (params["step"] as Float?) ?: 0f,
            collector = (params["collector"] as Int?) ?: -1,
            min_order = (params["min_order"] as Float?) ?: 0f,
            unit_preferece = (params["unit_preferece"] as Int?),
            armor = (params["armor"] as Float?),
            days_ahead = (params["days_ahead"] as Int?),
            third_unit = (params["third_unit"] as String?)?.let { WrappedName.convertFrom(it)?.state } ?: 0,
            day_hour_locks = params["day_hour_locks"] as String?,
            delivery_cutoff_rules = params["delivery_cutoff_rules"] as String?,
            position = (params["orderPosition"] as Int?))
        else
            product.first?.getOrderProduct()?.let { Respone(it, DBQuery.SUCCESS) } ?: Respone(null, DBQuery.SUCCESS)

        if (newOrderProduct.second != DBQuery.SUCCESS) {
            return Respone(product.first, newOrderProduct.second)
        }
        if (params["image"] != null) {

            val byteArr = params["image"]!! as ByteArray
            val img = this.uploadImg(
                f = byteArr, product_id = product.first!!.id
            )

        }

        if (params.containsKey("addToSupplier") && !(product.first!!.getConnectedProduct()
                .isNotEmpty() || getAllSupplierProduct(false).first.any {
                it.getName().compareTo(product.first!!.getName()) == 0
            })
        ) {
            val newSupProduct = this.newSupplierProduct(
                name = product.first.name,
                date = params["date"]!! as String,
                barcode = product.first.barcode,
                default_price = 0f,
                connected_product = product.first.id,
                no_tax_product = product.first.no_tax_product,
                category = product.first.category,
                category2 = product.first.category2,

                )
            if (newSupProduct.second != DBQuery.SUCCESS) {
                return Respone(product.first, newSupProduct.second)
            }
        }
        if (id == null && params.containsKey("notAvailable")) {
            val pId = product.first!!.id
            this.newAllAvailable(getAllClient(true).first.map {
                Available(id = it.id, product_id = pId, available = 0)
            })

        }
        if (params.containsKey("cost_price_updated") && params["cost_price_updated"] != null) {
            val costPrice = params["cost_price_updated"] as Float?
            if (costPrice != null) {

                this.updateAllSpecialProductPrice(
                    ids = listOf(-1),
                    product_id = listOf(product.first!!.id),
                    date = DatesManipulator.minDay(params["date"]!! as String),
                    toDate = params["date"]!! as String,
                    price = costPrice,
                    tax_mutate = false
                )
            }
        }
        return product
    }


    // API
    suspend fun getMsgTracker(
        params: HashMap<String, Any>
    ): Respone<List<MsgTracker>, DBQuery> {

        return this.getMsgTracker(
            msg_id = params["msg_id"] as Int?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            type = params["type"] as Int?,
            send = params["send"] as Int?,
            tries = params["tries"] as Int?,
            validate = params["validate"] as Int?,
            unique_id = params["unique_id"] as List<Int>?,
            limit = params["limit"] as Int?,
            date_created = params["date_created"] as String?
        )
    }

    suspend fun newAllMsgTracker(
        params: HashMap<String, Any>
    ): Respone<List<MsgTracker>, DBQuery> {
        return this.newAllMsgTracker(
            data = params["data"] as List<MsgTracker>,
            date = params["date"] as String,
        )
    }


    suspend fun buildClientApiNotes(
        params: HashMap<String, Any>
    ): Respone<List<ApiNote>, DBQuery> {

        return this.getApiNote(
            doc_ids = params["ids"] as List<Int>?,
            doc_type = params["doc_type"] as Int?,
            connected_id = params["connected_id"] as Long?,
            api_method = params["api_method"] as Int?,
            send = params["send"] as Int?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            full = params["full"] as Boolean? ?: false,
            retries = params["retries"] as Int?,
        )
    }

    suspend fun setClientApiNotes(
        params: HashMap<String, Any>
    ): Respone<List<ApiNote>, DBQuery> {

        return this.setApiNote(
            doc_id = params["doc_id"] as Int,
            doc_type = params["doc_type"] as Int,
            api_method = params["api_method"] as Int,
            doc_date = params["doc_date"] as String?,
            connected_id = params["connected_id"] as Long?,
            ent_id = params["ent_id"] as Int?,
            send = params["send"] as Int?,
            reason = params["reason"] as String?,
            retries = params["retries"] as Int?,
        )
    }


    suspend fun getAllSpecificClientDocuments(
        params: HashMap<String, Any>
    ): Respone<List<InformationBase>, DBQuery> {
        val client_id = params["client_id"] as Int?
        val client_ids = params["client_ids"] as List<Int>?
        val driver_id = params["driver_id"] as Int?

        val client = client_id?.let { getClient(it).first }
        val fromDate = params["fromDate"] as String
        val toDate = params["toDate"] as String
        val fromDrivers = client_ids ?: driver_id?.let {
            buildClientsDailyData(date = toDate, driver_id = listOf(it)).first.map { it.id }
        }
        val full = (params["full"] as Boolean?) ?: false
        val apis = (params["api"] as Boolean?) ?: true
        val tax_only = (params["tax_only"] as Boolean?) ?: false
        val visit = (params["visit"] as Boolean?) ?: false
        val onlyProducts = (params["onlyProducts"] as Boolean?) ?: false
        val cost = (params["cost"] as Boolean?) ?: false
        val productIds = params["product_ids"] as List<Int>?
        val result: MutableList<InformationBase> = mutableListOf()
        val calls: MutableList<suspend () -> Respone<List<InformationBase>, DBQuery>> = mutableListOf()
        val documents = (params["force_documents"] as List<Int>?)?.toSet()


        if (!tax_only) {
            if (documents == null || documents.contains(DocType.DELIVERY_NOTES.state))
                calls.add(suspend {

                    if (full && false) {
                        this.getOptimizedClientNote(
                            ent_id = fromDrivers ?: client_id?.let { listOf(it) },
                            fromDate = fromDate,
                            toDate = toDate,
                            full = full
                        )
                    } else {
                        this.buildClientNotes(
                            client_id = client_id,
                            fromDate = fromDate,
                            toDate = toDate,
                            full = false,
                            client_ids = fromDrivers, priced = false,
                            product_ids = productIds,
                        )
                    } as Respone<List<InformationBase>, DBQuery>
                })


            if (documents == null || documents.contains(DocType.ORDERS.state))
                calls.add(suspend {

                    if (full && false) this.getOptimizedClientNote(
                        ent_id = fromDrivers ?: client_id?.let { listOf(it) },
                        fromDate = fromDate,
                        toDate = toDate,
                        full = full,
                        order = true
                    )
                    else {
                        this.buildClientOrderNotes(

                            fromDate = fromDate,
                            toDate = toDate,
                            full = false,
                            withoutInventory = true,
                            client_ids = fromDrivers ?: client_id?.let { listOf(it) },
                            priced = false,
                            product_ids = productIds,
                        )
                    } as Respone<List<InformationBase>, DBQuery>
                })

        }

        val ids = fromDrivers?.let { getAllClientsWithBranches(it).first } ?: if (client?.hasBranch() == true) {
            getBranchMembers(client.branch, false).first.map { it.id }

        } else {
            client_id?.let { listOf(it) }
        }
        if (documents == null || documents.contains(DocType.TAX_NOTE.state))
            calls.add(suspend {

                this.buildClientTaxNote(
                    client_ids = ids,
                    fromDate = fromDate,
                    toDate = toDate,
                    full = false,
                    withProduct = if (onlyProducts) 1 else null,
                    product_ids = productIds,
                ) as Respone<List<InformationBase>, DBQuery>
            })

        if (!onlyProducts) {
            if (documents == null || documents.contains(DocType.PAY_NOTE.state))
                calls.add(suspend {

                    this.buildClientPay(
                        client_ids = ids, fromDate = fromDate, toDate = toDate, full = false
                    ) as Respone<List<InformationBase>, DBQuery>
                })

            if (documents == null || documents.contains(DocType.PAY_NOTE.state))
                calls.add(suspend {
                    this.buildClientCartesetMap(
                        ids = ids, fromDate = fromDate, toDate = toDate
                    ) as Respone<List<InformationBase>, DBQuery>

                })


        }

        if (visit) {
            // Visit notes are per-client; do not expand to the whole network/branch.
            val visitEntIds = fromDrivers ?: client_id?.let { listOf(it) }
            if (documents == null || documents.contains(DocType.VISIT.state))
                calls.add(suspend {
                    this.buildClientVisitNote(
                        ent_ids = visitEntIds, fromDate = fromDate, toDate = toDate, full = false
                    ) as Respone<List<InformationBase>, DBQuery>

                })

        }

        val executor =
            ((if (false && getUser().first?.company_type == 4) ParallelExecutor() else SerialExecutor()) as Executor).getInfo(
                calls,
                { respone ->
                    (respone.second) == DBQuery.SUCCESS
                },
                { index, respone ->
                    result.addAll(respone.first)
                })
        if (cost) {
            val costs = buildClientCosts(fromDate, toDate, listOf(-1))
        }


        if (!executor) return Respone(listOf(), DBQuery.FAILED)
        val productIdSet = productIds?.filter { it > 0 }?.toSet()
        if (!productIdSet.isNullOrEmpty()) {
            result.retainAll { doc -> doc.getConnectedProductsIds().any { pid -> pid in productIdSet } }
        }
        val q = if (full)
            buildFullOnDocs(result, api = apis,priced=false)
        else DBQuery.SUCCESS
        return Respone(result, q)

    }

    suspend fun getAllSpecificSupplierDocuments(
        params: HashMap<String, Any>
    ): Respone<List<InformationBase>, DBQuery> {
        val sup_id = params["sup_id"] as Int?

        val client = sup_id?.let { getSupplier(it).first }
        val fromDate = params["fromDate"] as String
        val toDate = params["toDate"] as String

        val full = (params["full"] as Boolean?) ?: false
        val apis = (params["api"] as Boolean?) ?: true
        val tax_only = (params["tax_only"] as Boolean?) ?: false
        val visit = (params["visit"] as Boolean?) ?: false
        val onlyProducts = (params["onlyProducts"] as Boolean?) ?: false
        val cost = (params["cost"] as Boolean?) ?: false
        val result: MutableList<InformationBase> = mutableListOf()
        val calls: MutableList<suspend () -> Respone<List<InformationBase>, DBQuery>> = mutableListOf()
        val documents = (params["force_documents"] as List<Int>?)?.toSet()


        if (!tax_only) {
            if (documents == null || documents.contains(DocType.DELIVERY_NOTES.state))
                calls.add(suspend {
                    this.buildSupplierNotes(

                        fromDate = fromDate,
                        toDate = toDate,
                        full = false,
                        supplier_id = sup_id
                    ) as Respone<List<InformationBase>, DBQuery>

                })

        }


        if (documents == null || documents.contains(DocType.SUPPLIER_INVOICE.state))
            calls.add(suspend {

                this.buildClientTaxNote(
                    client_id = sup_id,
                    fromDate = fromDate,
                    toDate = toDate,
                    full = false,
                    sup = true,
                    withProduct = if (onlyProducts) 1 else null
                ) as Respone<List<InformationBase>, DBQuery>
            })

        if (!onlyProducts) {
            if (documents == null || documents.contains(DocType.SUPPLIER_PAYMENT.state))
                calls.add(suspend {

                    this.buildClientPay(
                        client_id = sup_id, fromDate = fromDate, toDate = toDate, full = false, sup = true
                    ) as Respone<List<InformationBase>, DBQuery>
                })

            if (documents == null || documents.contains(DocType.SUPPLIER_PAYMENT.state))
                calls.add(suspend {
                    this.buildClientCartesetMap(
                        id = sup_id, fromDate = fromDate, toDate = toDate, sup = true
                    ) as Respone<List<InformationBase>, DBQuery>

                })


        }


        val executor =
            ((if (false && getUser().first?.company_type == 4) ParallelExecutor() else SerialExecutor()) as Executor).getInfo(
                calls,
                { respone ->
                    (respone.second) == DBQuery.SUCCESS
                },
                { index, respone ->
                    result.addAll(respone.first)
                })



        if (!executor) return Respone(listOf(), DBQuery.FAILED)
        val q = if (full)
            buildFullOnDocs(result, api = apis, sup = true)
        else DBQuery.SUCCESS
        return Respone(result, q)

    }

    suspend fun getDocumentPDF(
        params: HashMap<String, Any>
    ): Respone<ByteArray?, DBQuery> {

        val doc = params["doc"] as InformationBase
        val origin = (params["origin"] as Boolean?)?.let { if (it) 1 else 0 } ?: 1
        val force_price = (params["force_price"] as Boolean?)
        val type = doc.getConnectedDocType()
        val date = doc.getConnectedDate()
        val year = DatesManipulator.getYear(date)
        val month = number_to_month[DatesManipulator.getMonth(date).toInt()]!!
        val ent_id = doc.getConnectedEntId()
        val doc_id = doc.getConnectedId()
        val requestedSup = when (val v = params["sup"]) {
            is Boolean -> v
            is Number -> v.toInt() != 0
            is String -> v.equals("true", ignoreCase = true)
            else -> false
        }
        val taxNote = doc as? ClientTaxNote
        val supplierTax = requestedSup || (taxNote != null && !taxNote.isClient) ||
            type == DocType.SUPPLIER_INVOICE.state ||
            type == DocType.SUPPLIER_INVOICE_RECEIPT.state ||
            type == DocType.SUPPLIER_INVOICE_CREDIT.state
        val effectiveType =
            if (supplierTax && type in 0..2) type + DocType.SUPPLIER_INVOICE.state else type
        return when (effectiveType) {
            DocType.TAX_NOTE.state, DocType.TAX_PAY_NOTE.state, DocType.TAX_NOTE_CANCEL.state -> {
                val client = (doc as ClientTaxNote).getClient()
                buildClientTaxNoteCyclePdf(
                    client_name = client.getName(date),
                    month = month,
                    year = year,
                    id = doc_id,
                    type = type,
                    origin = origin
                )
            }

            DocType.SUPPLIER_INVOICE.state, DocType.SUPPLIER_INVOICE_RECEIPT.state, DocType.SUPPLIER_INVOICE_CREDIT.state, DocType.SUPPLIER_PAYMENT.state -> {
                return this.calcMASSdocPdf(
                    ids = listOf(doc_id),
                    docs = listOf(effectiveType),
                    origin = origin == 1,
                    force_price = force_price,
                    sup = true,
                )
            }

            DocType.DELIVERY_NOTES.state -> {
                buildClientDeliveryNotePdf(
                    id = doc_id, origin = origin, force_price = force_price
                )
            }

            DocType.VISIT.state -> {
                if ((doc as VisitNote).order_id != null && doc.order_id != -1) {
                    return this.calcMASSdocPdf(
                        ids = listOf(doc.order_id!!),
                        docs = listOf(DocType.ORDERS.state),
                        sup = false,
                    )
                } else
                    return Respone(null, DBQuery.FAILED)

            }

            DocType.ORDERS.state -> {
                calcClientOrderPdf(
                    ids = listOf(doc_id)
                )
            }

            DocType.SUP_DELIVERY_NOTES.state -> {
                return this.calcMASSdocPdf(
                    ids = listOf(doc_id),
                    docs = listOf(effectiveType),
                    origin = origin == 1,
                    force_price = force_price,
                    sup = true,
                    )
            }

            DocType.PAY_NOTE.state -> {
                val pay = doc as ClientPay
                val ent: Entity = if (pay.isClient) pay.getClient() else pay.getSupplier()
                buildClientPayCyclePdf(
                    client_name = ent.getName(date),
                    month = month,
                    year = year,
                    id = doc_id,
                    origin = origin,
                    sup = !pay.isClient
                )
            }

            else -> {
                Respone(null, DBQuery.FAILED)
            }
        }
    }

    suspend fun closeDocuments(
        params: HashMap<String, Any>
    ): DBQuery {
        val docs = params["docs"] as List<Int>
        val types = params["doc_types"] as List<Int>
        val pairs = docs.zip(types)
        pairs.groupBy { it.second }.forEach {
            when (it.key) {
                DocType.TAX_NOTE.state, DocType.TAX_PAY_NOTE.state, DocType.TAX_NOTE_CANCEL.state -> {
                    val q = updateAllClientTaxNotes(it.value.map { it.first },
                        it.value.map { it.second },
                        value_left = it.value.map { 0f },
                        active_state = it.value.map { 2 })

                    if (q.second != DBQuery.SUCCESS) {
                        return q.second
                    }
                }

                DocType.SUPPLIER_INVOICE.state, DocType.SUPPLIER_INVOICE_RECEIPT.state, DocType.SUPPLIER_INVOICE_CREDIT.state -> {
                    val q = updateAllClientTaxNotes(
                        it.value.map { pair -> pair.first },
                        it.value.map { pair -> pair.second - DocType.SUPPLIER_INVOICE.state },
                        value_left = it.value.map { 0f },
                        active_state = it.value.map { 2 },
                        sup = true
                    )

                    if (q.second != DBQuery.SUCCESS) {
                        return q.second
                    }
                }

                DocType.DELIVERY_NOTES.state -> {
                    val ids = it.value.map { it.first }
                    val q = updateAllClientNotes(delivery_ids = ids, paid = it.value.map { 1 })

                    if (q.second != DBQuery.SUCCESS) {
                        return q.second
                    }
                }

                DocType.SUP_DELIVERY_NOTES.state -> {
                    val q = closeSupplierDeliveryNote(it.value.map { pair -> pair.first })
                    if (q.second != DBQuery.SUCCESS) {
                        return q.second
                    }
                }

            }
        }
        return DBQuery.SUCCESS
    }

    suspend fun activeDocument(
        params: HashMap<String, Any>
    ): Respone<InformationBase?, DBQuery> {
        val doc = params["doc"] as InformationBase
        val date = params["date"] as String
        val active = params["active"] as Boolean
        val agent = params["agent"] as String
        val increase_id = params["increase_id"] as Int?
        val type = doc.getConnectedDocType()
        val curAgent = agents.firstOrNull { it.user_name == agent }

        return when (type) {
            DocType.TAX_NOTE.state, DocType.TAX_PAY_NOTE.state, DocType.TAX_NOTE_CANCEL.state -> {
                cancelClientTaxNote(
                    id = doc.getConnectedId(), type = type, date = date, agent = agent, increase_id = increase_id
                ) as Respone<InformationBase?, DBQuery>
            }

            DocType.SUPPLIER_INVOICE.state, DocType.SUPPLIER_INVOICE_CREDIT.state, DocType.SUPPLIER_INVOICE_RECEIPT.state -> {
                cancelClientTaxNote(
                    id = doc.getConnectedId(),
                    type = type - 16,
                    date = date,
                    agent = agent,
                    sup = true,
                    increase_id = increase_id
                ) as Respone<InformationBase?, DBQuery>
            }

            DocType.DELIVERY_NOTES.state -> {
                if (!active && curAgent?.note_cancel == 2) {
                    deActivate(
                        "client",
                        doc as DeliveryNote,
                        2,
                        increase_id = increase_id
                    ) as Respone<InformationBase?, DBQuery>

                } else
                    updateClientNote(
                        delivery_id = doc.getConnectedId(), active = if (active) 1 else 0

                    ) as Respone<InformationBase?, DBQuery>
            }

            DocType.ORDERS.state -> {

                updateClientOrderNote(
                    order_id = doc.getConnectedId(),
                    active = if (active) 1 else 0,
                    e_agent = agent,
                    inventory = if (doc.getConnectedEntId() == -1) "1" else null

                ) as Respone<InformationBase?, DBQuery>
            }

            DocType.PAY_NOTE.state, DocType.SUPPLIER_PAYMENT.state -> {
                cancelClientPay(
                    id = doc.getConnectedId(),
                    date = date,
                    agent = agent,
                    increase_id = increase_id,
                    sup = type == DocType.SUPPLIER_PAYMENT.state
                ) as Respone<InformationBase?, DBQuery>
            }

            DocType.SUP_DELIVERY_NOTES.state -> {
                updateSupplierDeliveryNote(
                    delivery_id = doc.getConnectedId(), active = if (active) 1 else 0
                ) as Respone<InformationBase?, DBQuery>
            }

            DocType.VISIT.state -> {
                updateClientVisitNote(
                    id = doc.getConnectedId(), active = active
                ) as Respone<InformationBase?, DBQuery>
            }

            else -> {
                Respone(null, DBQuery.FAILED)
            }
        }
    }

    suspend fun queryData(
        params: HashMap<String, Any>
    ): Respone<List<DataQueryHolder?>?, DBQuery> {

        return this.queryData(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            byProduct = params["byProduct"] as List<Int>?,
            byEnt = params["byEnt"] as List<Int>?,
            byAgent = params["byAgent"] as List<String>?,
            byMoney = params["byMoney"] as Boolean?,
            byCost = params["byCost"] as Boolean?,
            byMonth = params["byMonth"] as Int?,
            byYear = params["byYear"] as Int?,

            doc_type = (params["doc_type"] as Int?) ?: 4,
            withDaily = (params["withDaily"] as Boolean?) ?: false,
            cofc = (params["cofc"] as Int?),
            paid = (params["paid"] as Boolean?),
            filter_date = params["filter_date"] as String?,
            byDocId = params["byDocId"] as Int?,
            byCostTax = params["byCostTax"] as Boolean?,

            )
    }

    suspend fun queryBaseDays(
        params: HashMap<String, Any>
    ): Respone<List<DataQueryHolder?>?, DBQuery> {
        val realFrom = params["fromDate"] as String
        val realTo = params["toDate"] as String
        val showReal = (params["showReal"] as Boolean?) ?: false
        val fromDate = if (showReal) realFrom else baseOrderDaysToData[1]
        val toDate = if (showReal) realTo else baseOrderDaysToData[6]
        val data = this.queryData(
            fromDate = fromDate!!,
            toDate = toDate!!,
            byProduct = params["byProduct"] as List<Int>?,
            byEnt = params["byEnt"] as List<Int>?,
            byDay = -1,
            byAgent = params["byAgent"] as List<String>?,
            byMoney = params["byMoney"] as Boolean?,
            byCost = params["byCost"] as Boolean?,
            byMonth = params["byMonth"] as Int?,
            byYear = params["byYear"] as Int?,
            doc_type = 10,
            withDaily = false,
        )
        if (data.second != DBQuery.SUCCESS) {
            return Respone(listOf(), data.second)
        }
        val daysMapCountBetween =
            DatesManipulator.getDatesRange(realFrom, realTo).map { DatesManipulator.getDayOfWeekIsrael(it) }
                .groupingBy { it }.eachCount()
        if (!showReal)
            data.first?.forEach {
                it?.let {
                    it.multiply(((daysMapCountBetween[it.byDay] ?: 1).toFloat()))


                }
            }
        val g = DataQueryHolder.toGroupAggregate(
            data.first as List<DataQueryHolder>,
            false,
            false,
            false,
            (params["byDay"] as Boolean?) ?: false,
            true,
            true,
            false
        )
        return Respone(g, DBQuery.SUCCESS)
    }

    suspend fun changeBaseAmount(
        params: HashMap<String, Any>
    ): Respone<List<OrderNote>, DBQuery> {
        val fromDate = baseOrderDaysToData[1]
        val toDate = baseOrderDaysToData[6]
        val data = params["data"] as List<baseChangeHolder>
        val clients = data.map { it.c_id }.distinct()

        val o = buildClientOrderNotes(
            client_ids = clients,
            fromDate = fromDate!!,
            toDate = toDate!!,
        )



        if (o.second != DBQuery.SUCCESS) {
            return Respone(o.first, o.second)
        }
        val isNull = data.filter { it.day == null }
        var useData = data.filter { it.day != null }.toMutableList()
        if (isNull.isNotEmpty()) {
            var insertion: MutableList<baseChangeHolder> = mutableListOf()
            // we need algo to fiex the data
            val bases = isNull.groupBy { Pair(it.c_id, it.p_id) }
            o.first.forEach { on ->
                on.delivery_info.forEach {
                    insertion.add(
                        baseChangeHolder(
                            on.ent_id,
                            it.productId,
                            it.value + it.wrapped_amount * it.conversion_ratio,
                            day = DatesManipulator.getDayOfWeekIsrael(on.date)
                        )
                    )
                }
            }
            var newBases: MutableList<baseChangeHolder> = mutableListOf()
            val orderInsertion = insertion.groupBy { Pair(it.c_id, it.p_id) }
            bases.forEach { (k, v) ->
                if (orderInsertion.containsKey(k)) {
                    val base = v.first()
                    val orders = orderInsertion[k]!!
                    val curSum = orders.sumOf { it.amount.toDouble() }
                    var baseAmount = base.amount
                    orders.forEachIndexed { index, baseChangeHolder ->
                        val ratioAmount = (baseChangeHolder.amount / curSum * baseAmount).roundToInt().toFloat()

                        if (index == orders.size - 1) {
                            newBases.add(baseChangeHolder(base.c_id, base.p_id, baseAmount, day = baseChangeHolder.day))
                        } else {
                            newBases.add(
                                baseChangeHolder(
                                    base.c_id,
                                    base.p_id,
                                    ratioAmount,
                                    day = baseChangeHolder.day
                                )
                            )
                            baseAmount -= ratioAmount
                        }

                    }

                }
            }
            useData.addAll(newBases)

        }


        val bases = useData.groupBy { Triple(it.c_id, it.p_id, it.day) }


        val insertion: MutableList<List<ProductDelivery>> = mutableListOf()
        val ids: MutableList<Int> = mutableListOf()
        o.first.forEach { on ->
            val day = DatesManipulator.getDayOfWeekIsrael(on.date)
            var changed = false
            val dvs = on.delivery_info.mapNotNull {
                val key = Triple(on.ent_id, it.productId, day)
                if (bases.containsKey(key)) {
                    val base = bases[key]!!.first()
                    changed = true
                    if (base.amount == 0f)
                        null
                    else it.copy(value = base.amount, wrapped_amount = 0f)


                } else
                    it
            }
            if (changed) {
                insertion.add(dvs)
                ids.add(on.order_id)
            }

        }
        if (ids.isNotEmpty())
            return this.updateAllClientOrders(
                order_ids = ids, pds = insertion
            )
        return Respone(listOf(), DBQuery.SUCCESS)

//        o.first.forEach { on->
//            on.delivery_info.forEach {
//                insertion.add(baseChangeHolder(on.ent_id, it.productId, it.value+it.wrapped_amount*it.conversion_ratio,day=DatesManipulator.getDayOfWeekIsrael(on.date)))
//            }
//        }
//        val orders = insertion.groupBy { Pair(it.c_id,it.p_id) }
//        val newInsert:MutableList<baseChangeHolder> = mutableListOf()
//
//        orders.forEach {
//            val key = it.key
//            val base = bases[key]
//            val order = it.value
//            val baseData = base?.first()
//            val orderData = order.first()
//            if(baseData != null && orderData != null){
//                val newAmount = baseData.amount - orderData.amount
//                if(newAmount != 0f){
//                    newInsert.add(baseChangeHolder(baseData.ent_id, baseData.p_id, newAmount, day = baseData.day))
//                }
//            }
//        }
//        bases.forEach {
//            val client = it.key
//            val clientOrders = orders[client] ?: listOf()
//            val clientData = it.value
//
//
//
//        }


    }

    suspend fun matchData(
        params: HashMap<String, Any>
    ): Respone<Pair<List<DataQueryHolder?>?, List<DataQueryHolder?>?>, DBQuery> {
        val first_query = params["first_query"] as Int
        val second_query = params["second_query"] as Int

        val first = this.queryData(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            byProduct = params["byProduct"] as List<Int>?,
            byEnt = params["byEnt"] as List<Int>?,
            byAgent = params["byAgent"] as List<String>?,
            byMoney = params["byMoney"] as Boolean?,
            byCost = params["byCost"] as Boolean?,
            doc_type = first_query,
            withDaily = (params["withDaily"] as Boolean?) ?: false,
            cofc = (params["cofc"] as Int?),
            paid = (params["paid"] as Boolean?),
            filter_date = params["filter_date"] as String?,
        )
        val second = this.queryData(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            byProduct = params["byProduct"] as List<Int>?,
            byEnt = params["byEnt"] as List<Int>?,
            byAgent = params["byAgent"] as List<String>?,
            byMoney = params["byMoney"] as Boolean?,
            byCost = params["byCost"] as Boolean?,
            doc_type = second_query,
            withDaily = (params["withDaily"] as Boolean?) ?: false,
            cofc = (params["cofc"] as Int?),
            paid = (params["paid"] as Boolean?),
            filter_date = params["filter_date"] as String?,
        )
        if (first.second == DBQuery.SUCCESS && second.second == DBQuery.SUCCESS) {
            return Respone(Pair(first.first, second.first), DBQuery.SUCCESS)
        }
        return Respone(Pair(null, null), DBQuery.FAILED)
    }


    suspend fun newClientsAllNotes(
        params: HashMap<String, Any>
    ): Respone<List<InformationBase>, DBQuery> {
        var date = params["date"] as String?
        var toDate = params["toDate"] as String?
        var order_id = params["order_ids"] as List<Int?>?
        val ids = params["ids"] as List<Int>
        val pds = params["pds"] as List<List<ProductDelivery>>
        var notes = (params["notes"] as List<String>?)?.map {
            prepareStrToJson(it)

        }
        var notes2 = (params["notes2"] as List<String>?)?.map {
            prepareStrToJson(it)

        }
        var notes3 = (params["notes3"] as List<String>?)?.map {
            prepareStrToJson(it)

        }
        var notes4 = (params["notes4"] as List<String>?)?.map {
            prepareStrToJson(it)

        }
        var notes5 = (params["notes5"] as List<String>?)?.map {
            prepareStrToJson(it)

        }
        val dates=(params["dates"] as List<String>?)
        var agent = params["agent"] as String
        val agents = getAgents().first
        // Empty name must not resolve to an agent (e.g. agent id with blank user_name).
        var orderAgents = (params["orderAgents"] as List<String>?)?.map {
            val driver = agents.firstOrNull { ag -> ag.user_name != "" && it != "" && ag.user_name == it }?.id ?: -1
            driver

        }
        return this.newAllClientNotes(
            date = date!!,
            agent = agent,
            agent_id = orderAgents,
            ids = ids,
            pds = pds,
            order_id = order_id,
            notes = notes,
            notes2 = notes2,
            notes3 = notes3,
            notes4 = notes4,
            notes5 = notes5,
            withTaxNotes = (params["withTaxNotes"] as Boolean?) ?: false,
            round = (params["round"] as Boolean?) ?: false,
            dates=dates,
            toDate=toDate,
            onlyInsert = (params["onlyInsert"] as Boolean?) ?: false

            )
    }

    suspend fun updateAllClientTaxNotes(
        params: HashMap<String, Any>
    ): Respone<List<ClientTaxNote>, DBQuery> {

        var ids = params["ids"] as List<Int>
        var types = params["types"] as List<Int>
        var active_state = params["active_state"] as List<Int>?
        var value_left = params["value_left"] as List<Float>?
        var order_id = params["order_id"] as List<Int>?
        var external_details = params["external_details"] as List<String>?
        var payments = params["paymentsData"] as List<List<PaymentData>>?
        var notes2 = params["notes2"] as List<String>?
        var notes3 = params["notes3"] as List<String>?
        var notes4 = params["notes4"] as List<String>?
        var notes5 = params["notes5"] as List<String>?
        var taxConfirmation = params["taxConfirmation"] as List<String>?
        var supplier_invoice_number = params["supplier_invoice_number"] as List<String>?
        var agent = params["agent"] as String?
        val agents = getAgents().first
        // Empty name must not resolve to an agent (e.g. agent id with blank user_name).
        var orderAgents = (params["orderAgents"] as List<String>?)?.map {
            val driver = agents.firstOrNull { ag -> ag.user_name != "" && it != "" && ag.user_name == it }?.id ?: -1
            driver

        }
        var pdf = params["pdf"] as List<Int>?
        val sup = params["sup"] as Boolean? ?: false

        return this.updateAllClientTaxNotes(
            ids = ids,
            types = types,
            active_state = active_state,
            external_details = external_details,
            order_id = order_id,
            notes2 = notes2,
            notes3 = notes3,
            notes4 = notes4,
            notes5 = notes5,
            value_left = value_left,
            payments = payments,
            agent = agent,
            agent_id = orderAgents,
            taxConfirmation = taxConfirmation,
            supplier_invoice_number = supplier_invoice_number,
            increase_id = params["increase_id"] as Int?,
            pdf = pdf,
            sup = sup,
            document_dates = params["document_dates"] as List<String>?,
            values = (params["values"] as List<*>?)?.map { (it as Number).toFloat() },
            total_values = (params["total_values"] as List<*>?)?.map { (it as Number).toFloat() },
            discount_percents = (params["discount_percents"] as List<*>?)?.map { (it as Number).toFloat() },
            dataValues = params["dataValues"] as List<List<ClientTaxNoteData>>?,
            details = params["details"] as List<ClientStaticData>?,
            client_ids = (params["client_ids"] as List<*>?)?.map { (it as Number).toInt() },
        )
    }

    suspend fun updateAllClientNotes(
        params: HashMap<String, Any>
    ): Respone<List<DeliveryNote>, DBQuery> {
        var delivery_ids = params["delivery_ids"] as List<Int>
        var active = params["actives"] as List<Int>?
        var order_id = params["order_ids"] as List<Int>?
        var paid = params["paids"] as List<Int>?
        var pdf = params["pdf"] as List<Int>?
        return this.updateAllClientNotes(
            delivery_ids = delivery_ids, active = active, order_id = order_id, paid = paid, pdf = pdf
        )
    }

    suspend fun updateAllClientOrders(
        params: HashMap<String, Any>
    ): Respone<List<OrderNote>, DBQuery> {
        var categories = params["categories"] as List<String>?
        var status = (params["status"] as List<String>?)?.map {
            OrderStatus.REGULAR.inverseName(it)
        }
        var date = (params["date"] as String?)

        var order_id = params["order_ids"] as List<Int>
        var notes = (params["notes"] as List<String>?)?.map {
            prepareStrToJson(it)
        }

        var notes2 = (params["notes2"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes3 = (params["notes3"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes4 = (params["notes4"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes5 = (params["notes5"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        val agents = getAgents().first
        // Empty name must not resolve to an agent (e.g. agent id with blank user_name).
        // Without this, orderAgents="" matches a blank-named agent and wrongly sets agent_id.
        var orderAgents = (params["orderAgents"] as List<String>?)?.map {
            val driver = agents.firstOrNull { ag -> ag.user_name != "" && it != "" && ag.user_name == it }?.id ?: -1
            driver

        }
        var agent = params["agent"] as String?
        val dup = params["dup"] as Boolean? ?: false
        if (dup && date != null) {
            val orders = buildClientOrderNotes(order_ids = order_id).first
            val ids = orders.map { it.ent_id }
            val pds = orders.map { it.delivery_info }

            // Carry the source orders' notes/comment, category, forced driver, and per-order
            // temporary details (static_data = שם עסק/כתובת מאולצים, force_position, delivery_date)
            // onto the duplicated orders — without these, a duplicate is created with empty notes
            // and lost one-off address/name (products live in delivery_info and survived).
            return this.newAllClientOrders(
                ids = ids,
                pds = pds,
                date = date,
                agent = "שכפול",
                run_over = true,
                notes = orders.map { it.notes },
                notes2 = orders.map { it.notes2 },
                notes3 = orders.map { it.notes3 },
                notes4 = orders.map { it.notes4 },
                notes5 = orders.map { it.notes5 },
                notes6 = orders.map { it.notes6 },
                notes7 = orders.map { it.notes7 },
                notes8 = orders.map { it.notes8 },
                notes9 = orders.map { it.notes9 },
                notes10 = orders.map { it.notes10 },
                categories = orders.map { it.category },
                agent_id = orders.map { it.agent_id },
                static_datas = orders.map { src ->
                    val raw = src.static_data
                    if (raw.isNullOrEmpty() || raw == "null") "" else raw
                },
                force_positions = orders.map { it.force_position },
                delivery_dates = orders.map { it.delivery_date ?: "" },
            )
        } else
            return this.updateAllClientOrders(
                order_ids = order_id,
                status = status,
                categories = categories,
                agent = agent,
                date = date,
                notes = notes,
                notes2 = notes2,
                notes3 = notes3,
                notes4 = notes4,
                notes5 = notes5,
                agent_id = orderAgents,
                force_positions = (params["forcePositions"] as List<Int?>?),
                row_versions = (params["row_versions"] as? List<*>)?.mapNotNull { (it as? Number)?.toInt() },
            )
    }

    suspend fun newClientsAllOrders(
        params: HashMap<String, Any>
    ): Respone<List<OrderNote>, DBQuery> {

        val day = params["day"] as Int?
        var date = params["date"] as String?
        var toDate = params["toDate"] as String?
        var categories = params["categories"] as List<String>?
        var status = (params["status"] as List<String>?)?.map {
            OrderStatus.REGULAR.inverseName(it)
        }
        var notes = (params["notes"] as List<String>?)?.map {
            prepareStrToJson(it)
        }

        var notes2 = (params["notes2"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes3 = (params["notes3"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes4 = (params["notes4"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes5 = (params["notes5"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes6 = (params["notes6"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes7 = (params["notes7"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes8 = (params["notes8"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes9 = (params["notes9"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var notes10 = (params["notes10"] as List<String>?)?.map {
            prepareStrToJson(it)
        }
        var ref_ids = (params["ref_ids"] as List<String>?)?.map {
            it
        }
        val dates=(params["dates"] as List<String>?)
        val agents = getAgents().first
        var orderAgents = (params["orderAgents"] as List<String>?)?.map {
            val driver = agents.firstOrNull { ag -> ag.user_name != "" && it != "" && ag.user_name == it }?.id ?: -1
            driver

        }

        if (day != null) {
            date = baseOrderDaysToData[day]
            categories = categories?.map { if (it.isEmpty()) "בסיס" else it }
        }
        return this.newAllClientOrders(
            date = date!!,
            agent = params["agent"] as String,
            ids = params["ids"] as List<Int>,
            pds = params["pds"] as List<List<ProductDelivery>>,
            notes = notes,
            categories = categories,
            status = status,
            notes2 = notes2,
            notes3 = notes3,
            notes4 = notes4,
            notes5 = notes5,
            notes6 = notes6,
            notes7 = notes7,
            notes8 = notes8,
            notes9 = notes9,
            notes10 = notes10,
            agent_id = orderAgents,
            run_over = (params["run_over"] as Boolean?) ?: true,
            order_ids = params["order_ids"] as List<Int?>?,
            ref_ids = ref_ids,
            withHistory = (params["withHistory"] as Boolean?) ?: false,
            collection = params["collection"] as List<List<CollectionObject>>?,
            dates = dates,
            toDate = toDate,
            delivery_dates = (params["delivery_dates"] as List<String>?),
            static_datas = (params["static_datas"] as List<String>?),
            force_positions = (params["forcePositions"] as List<Int?>?),
            row_versions = (params["row_versions"] as? List<*>)?.mapNotNull { (it as? Number)?.toInt() },
        )
    }

    suspend fun calcOptimizedCartesetValue(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.calcOptimizedCartesetValue(
            ids = params["ids"] as List<Int>?, toDate = params["toDate"] as String?
        )
    }

    suspend fun calcSupOptimizedCartesetValue(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.calcSupOptimizedCartesetValue(
            ids = params["ids"] as List<Int>?, toDate = params["toDate"] as String?
        )
    }

    suspend fun buildAllProductImages(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.buildProductImages(
            state = params["state"] as Map<Int, ByteArrayValueStore>?,
        )
    }

    suspend fun calcClientsXslx(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcClientsXslx(params["clients"] as List<Int>?)
    }

    suspend fun calcProductsXslx(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcProductsXslx(params["products"] as List<Int>?)
    }

    suspend fun calcQuerySum(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        fun intOrNull(key: String) = (params[key] as? Number)?.toInt()
        fun boolOrNull(key: String): Boolean? = when (val v = params[key]) {
            null -> null
            is Boolean -> v
            is Number -> v.toInt() != 0
            else -> null
        }
        return this.calcQuerySum(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            ids = params["ids"] as List<Int>,
            title = params["title"] as String,
            issuer = params["issuer"] as String,
            withOrders = params["withOrders"] as Boolean?,
            withNotes = params["withNotes"] as Boolean?,
            specific_products = params["specific_products"] as List<Int>?,
            seperate = params["seperate"] as Int?,
            byIds = params["byIds"] as Int?,
            closed = params["closed"] as Boolean?,
            inventory = params["inventory"] as Int?,
            orders_vs_notes_layout = intOrNull("orders_vs_notes_layout"),
            only_qty_mismatch = boolOrNull("only_qty_mismatch"),
        )
    }

    suspend fun calcDriverOrderSum(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcDriverOrderSum(
            date = params["date"] as String,
            ids = params["ids"] as List<Int>,
            groupType = params["groupType"] as Int,
            withOrders = params["withOrders"] as Int?,
            withNotes = params["withNotes"] as Int?,
            specific_products = params["specific_products"] as List<Int>?,
            title = params["title"] as String?,
            seperate = params["seperate"] as Int?,
            byIds = params["byIds"] as Int?,
            date_range = params["date_range"] as String?,
            closed = params["closed"] as Boolean?,
            inventory = params["inventory"] as Int?,
        )
    }

    suspend fun calcEDI100(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcEDI100(
            tax_id = params["tax_id"] as Int,
            notes = params["notes"] as List<Int>?,

            )
    }

    suspend fun calcbkmvdata(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcbkmvdata(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            no_cancel = params["no_cancel"] as Boolean?,

            )
    }

    suspend fun calcpcn874(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcpcn874(
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            no_cancel = params["no_cancel"] as Boolean?,
            reportMonth = params["reportMonth"] as String?,
        )
    }

    suspend fun copyPriceFromClient(params: HashMap<String, Any>): DBQuery {
        val from = params["from"] as Int
        val to = params["to"] as Int
        val datefrom = params["fromDate"] as String
        val dateTo = params["toDate"] as String?
        val datePrice = params["datePrice"] as String
        return copyPriceFromClient(from, to, datefrom, dateTo, datePrice)

    }

    suspend fun getProductsStatistics(params: HashMap<String, Any>): Respone<List<OrderStatistics>, DBQuery> {
        val day = params["day"] as Int?
        val from = params["from"] as String?
        val ids = params["ids"] as List<Int>
        val date = params["to"] as String
        val withLast = params["withLast"] as Int?
        val month_counter = params["month_counter"] as Int?
        return getProductsStatistics(ids, date, day, from, withLast, month_counter)

    }

    suspend fun newAgent(params: HashMap<String, Any>): Respone<Agent?, DBQuery> {
        return newAgent(
            id = params["id"] as Int?,
            user_name = params["user_name"] as String,
            password = params["password"] as String?,
            type = params["type"] as Int,
            phone = params["phone"] as String?,
        )

    }

    suspend fun updateAgent(params: HashMap<String, Any>): Respone<List<Agent>, DBQuery> {
        val ids = params["ids"] as List<Int>
        val user_name = params["user_name"] as List<String>?
        val password = params["password"] as List<String>?
        val comment = params["comment"] as List<String>?
        val car = params["car"] as? List<String>?
        val display_name = params["display_name"] as? List<String>?
        val phone = params["phone"] as? List<String>?
        val start_point = params["start_point"] as? List<String>?
        val end_point = params["end_point"] as? List<String>?
        return updateAgent(
            ids, user_name, password, comment, car, display_name, start_point, end_point, phone
        )

    }

    suspend fun getClientsVisitationOptimized(
        params: HashMap<String, Any>
    ): Respone<Pair<List<ClientVisitationHolder>, List<String>>?, DBQuery> {
        return getClientsVisitationOptimized(
            ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            tax_visitation = params["tax_visitation"] as Boolean,
            note_visitation = params["note_visitation"] as Boolean,
            dv_visitation = params["dv_visitation"] as Boolean,
            allClients = params["allClients"] as Boolean,
        )
    }

    suspend fun getClientsDebts(
        params: HashMap<String, Any>
    ): Respone<List<ClientDebt>, DBQuery> {
        return getClientsDebts(
            ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
        )
    }

    suspend fun getSuppliersDebts(
        params: HashMap<String, Any>
    ): Respone<List<ClientDebt>, DBQuery> {
        return getSuppliersDebts(
            ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
        )
    }

    suspend fun getClientPayDetails(
        params: HashMap<String, Any>
    ): Respone<List<PaymentData>, DBQuery> {
        return getClientPayDetails(
            ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            paid = params["paid"] as Boolean?,
        )
    }

    suspend fun getOptimizedClientNote(
        params: HashMap<String, Any>
    ): Respone<List<Note>, DBQuery> {
        return this.getOptimizedClientNote(
            ent_id = params["ent_ids"] as List<Int>?,
            delivery_id = params["id"] as Int?,
            delivery_ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            full = params["full"] as Boolean? ?: false,
            open = params["open"] as Boolean?
        )
    }

    suspend fun sendEmail(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.sendEmail(
            f = params["f"] as ByteArray,
            email = params["email"] as String,
            title = params["title"] as String,
            doc_type = params["doc_type"] as Int?,
            doc_id = params["doc_id"] as Int?
        )
    }

    suspend fun sendReqForApi(
        params: HashMap<String, Any>
    ): DBQuery {
        return this.sendReqForApi(
            doc_type = params["doc_type"] as Int,
            doc_id = params["doc_id"] as Int,
            api_method = params["api_method"] as Int?,
        )
    }

    suspend fun loadXlsx(
        params: HashMap<String, Any>
    ): Respone<String?, DBQuery> {
        return this.loadXlsx(
            f = params["f"] as ByteArray,
            type = params["type"] as String?,
            date = params["date"] as String?,
            load_doc_id = params["load_doc_id"] as Boolean?,
            load_type = params["load_type"] as String
        )
    }

    suspend fun updateGeoNames(params: HashMap<String, Any>): Respone<List<Int>?, DBQuery> {
        return this.updateGeoNames(
            clients = params["ids"] as List<Int>,
            force = (params["force"] as Boolean?) ?: false,
        )
    }

    suspend fun getOptimizedRoute(params: HashMap<String, Any>): Respone<List<Int>?, DBQuery> {
        val ids = params["ids"] as List<Int>
        // When a date is provided, honor each client's order.static_data forced address (if any) for
        // that date instead of the client's own address — same rule as buildOptimizeRouteByDrivers.
        val date = params["date"] as String?
        val forcedAddressByClient = date?.let { this.resolveForcedAddressesByClient(ids, it) } ?: mapOf()
        return this.getOptimizedRoute(
            clients = ids,
            updateGeo = (params["geoTransfrom"] as Boolean?) ?: false,
            start_point = params["start_point"] as String?,
            end_point = params["end_point"] as String?,
            forcedAddresses = ids.map { forcedAddressByClient[it] },
        )
    }

    suspend fun buildOptimizeRouteByDrivers(params: HashMap<String, Any>): Respone<List<ClientDailyData>, DBQuery> {
        return this.buildOptimizeRouteByDrivers(
            client_id = params["ids"] as List<Int>,
            date = params["date"] as String,
            save = params["save"] as Boolean,
            start_point = params["start_point"] as String?,
            end_point = params["end_point"] as String?,
        )
    }

    /**
     * Flexible route optimization for orders — see [OrderRouteUnit] / [buildOptimizeRouteForOrders].
     * Wire contract (parallel arrays, no nullable list elements over the JS bridge): `order_ids[i] == -1`
     * means unit `i` is a plain client (daily route); any other value is the order carrying its own
     * forced driver/position (looked up locally — the order must already be loaded).
     */
    suspend fun buildOptimizeRouteForOrders(params: HashMap<String, Any>): Respone<OrderRouteOptimizationResult, DBQuery> {
        val entIds = params["ent_ids"] as List<Int>
        val orderIds = (params["order_ids"] as List<Int>?) ?: entIds.map { -1 }
        val units = entIds.mapIndexed { index, entId ->
            val orderId = orderIds.getOrNull(index) ?: -1
            val order = if (orderId != -1) this.getClientOrderNotes(order_id = orderId).first.firstOrNull() else null
            OrderRouteUnit(ent_id = entId, order = order)
        }
        return this.buildOptimizeRouteForOrders(
            units = units,
            date = params["date"] as String,
            save = (params["save"] as Boolean?) ?: false,
            start_point = params["start_point"] as String?,
            end_point = params["end_point"] as String?,
        )
    }

    suspend fun splitDriversClientsToCollectors(params: HashMap<String, Any>): Respone<List<ClientDailyData>, DBQuery> {
        return this.splitDriversClientsToCollectors(
            client_id = params["ids"] as List<Int>,
            driver_id = params["driver_id"] as List<Int>,
            collector_id = params["collector_id"] as List<Int>,
            date = params["date"] as String,
            save = params["save"] as Boolean,
            maxBoxSize = params["maxBoxSize"] as Int,
            inverseToCollectors = (params["inverseToCollectors"] as Boolean?) ?: false,
        )
    }

    suspend fun buildLogo(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {

        return this.buildLogo((params["cofc"] as Int?))
    }

    suspend fun reportError(params: HashMap<String, Any>): DBQuery {

        return this.reportError(
            data = params["data"] as String,
            agent = params["agent"] as String,
            version = params["version"] as String,

            )
    }

    suspend fun getInventory(params: HashMap<String, Any>): Respone<List<InventoryItem>, DBQuery> {

        return this.getInventory(
            product_id = params["product_id"] as List<Int>?,
            agent_id = params["agent_id"] as List<Int>?,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            last = (params["last"] as Boolean?) ?: false,
            byEnt = (params["byEnt"] as Int?) ?: -1,
        )
    }

    suspend fun getEstimatedInventory(params: HashMap<String, Any>): Respone<List<InventoryItem>, DBQuery> {

        return this.getEstimatedInventory(
            product_id = params["product_id"] as List<Int>?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            byEnt = (params["byEnt"] as Int?) ?: -1,
        )
    }

    suspend fun insertInventory(params: HashMap<String, Any>): DBQuery {

        return this.insertInventory(
            date = params["date"] as String,
            inventoryItems = params["inventoryItems"] as List<InventoryItem>,
        )
    }

    suspend fun clearInventory(params: HashMap<String, Any>): DBQuery {

        return this.clearInventory(
            product_id = params["product_id"] as List<Int>?,
            agent_id = params["agent_id"] as List<Int>?,
        )
    }

    suspend fun buildClientVisitDistinct(params: HashMap<String, Any>): Respone<List<ClientVisitHolder>, DBQuery> {

        return this.buildClientVisitDistinct(
            ids = params["ids"] as List<Int>?,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
        )
    }

    suspend fun getInventoryNote(params: HashMap<String, Any>): Respone<List<InventoryItem>, DBQuery> {
        val full = params["full"] as Boolean? ?: false
        val agent = params["agent_id"] as List<Int>?
        val empty = params["empty"] as Boolean? ?: false
        val inv_type = params["inv_type"] as Int?
        if (inv_type == 1 && agent != null) {
            val inv = mutableListOf<InventoryItem>()
            val gi = getInventory(
                agent_id = agent,
                fromDate = params["fromDate"] as String,
                toDate = params["toDate"] as String
            ).first.groupBy { it.agent_id }
            agent.forEach {
                val matchGi = (gi[it] ?: listOf()).map {
                    it.product_id to it.copy(
                        inventoryStart = it.valueSum,
                        inventoryStart2 = it.valueSumSec
                    )
                }.toMap()
                inv.addAll(matchGi.values)
                inv.addAll(InventoryItem.prepareAllItems(matchGi, it))

            }
            return Respone(inv, DBQuery.SUCCESS)


        } else
            if (empty && agent != null) {
                val inv = mutableListOf<InventoryItem>()
                agent.forEach {
                    inv.addAll(InventoryItem.prepareAllItems(mapOf(), it))
                }
                return Respone(inv, DBQuery.SUCCESS)
            }
        val inv = this.buildClientOrderNotes(
            client_id = -1,
            fromDate = params["fromDate"] as String,
            toDate = params["toDate"] as String,
            agent_id = agent,
        ).first.map { InventoryItem.orderNoteToInventoryItem(it, full) }.flatten().toMutableList()
        if (full && inv.isEmpty() && agent != null) {
            agent.forEach {
                inv.addAll(InventoryItem.prepareAllItems(mapOf(), it))
            }

        }

        return Respone(inv, DBQuery.SUCCESS)
    }

    suspend fun getClientCompare(params: HashMap<String, Any>): Respone<Pair<List<ClientCompareHolder>, List<Any>>, DBQuery> {
        val method = params["method"] as Int? ?: 0
        val date = params["date"] as String
        val agents = params["agents"] as List<String>?

        return this.getClientCompare(
            method = method,
            date = date,
            agents = agents,
            cost = params["cost"] as Boolean? ?: false,
        )
    }

    suspend fun sendMsgAll(params: HashMap<String, Any>): DBQuery {
        return sendMsgAll(
            ids = params["ids"] as List<Int>,
            msg = params["msg"] as String,
            title = params["title"] as String,
            doc_type = params["doc_type"] as List<Int>?,
            emails = params["emails"] as List<String>?,
            phones = params["phones"] as List<String>?,
            action_date = params["action_date"] as String?,
            special_arg = params["special_arg"] as String?,
            external_var = params["external_var"] as List<String>?,
            agent = params["agent"] as String?,
            unique_id = params["unique_id"] as Int?,
            show_cancel = when (val v = params["show_cancel"]) {
                is Boolean -> if (v) "1" else null
                is Int -> if (v != 0) "1" else null
                is String -> if (v == "1" || v.equals("true", ignoreCase = true)) "1" else null
                else -> null
            },


            )
    }

    suspend fun getTaxNoteToSum(params: HashMap<String, Any>): Respone<List<TaxNoteSum>, DBQuery> {
        printPlat("getTaxNoteToSum")
        val ids: List<Int> = params["ids"] as List<Int>
        val sup = (params["sup"] as Boolean?) ?: false
        val dvs = if (sup) buildSupplierNotes(delivery_ids = ids).first else buildClientNotes(delivery_ids = ids).first
        val sum = calcDeliveryNoteSumMap(dvs, if (sup) "supplier" else "client").first

        val s = sum.mapNotNull {
            if (it.key == -1)
                return@mapNotNull null
            val product = if (sup) getSupplierProduct(it.key).first!! else getClientProduct(it.key).first!!
            val currentTax = tax.get(dvs.maxOf { it.date })
            TaxNoteSum(
                it.key,
                product.name,
                amount = it.value.positiveInstances,
                returns = it.value.negativeInstances,
                price = it.value.price,
                discount = it.value.discount,
                priceMin = it.value.price_min,
                priceMax = it.value.price_max,
                priceBefore = if (product.no_tax_product == 1) it.value.price else it.value.price / currentTax,
                priceBeforeMin = if (product.no_tax_product == 1) it.value.price_min else it.value.price_min / currentTax,
                priceBeforeMax = if (product.no_tax_product == 1) it.value.price_max else it.value.price_max / currentTax,
                total = it.value.totalValue,
                totalBefore = if (product.no_tax_product == 1) it.value.totalValue else it.value.totalValue / currentTax
            )
        }
        return Respone(s, DBQuery.SUCCESS)
    }

    suspend fun refreshDocuments(params: HashMap<String, Any>): Respone<List<InformationBase>, DBQuery> {
        val documents = params["documents"] as List<Int>
        val types = params["types"] as List<Int>
        val full = params["full"] as Boolean? ?: false
        val offline = params["offline"] as Boolean? ?: false
        val force = params["force"] as Boolean?
        val docs = types.mapIndexed { index: Int, i: Int -> Pair(documents[index], i) }
        val groups = docs.groupBy { it.second }
        val result = mutableListOf<InformationBase>()
        if (offline) {
            groups.forEach { (t, u) ->
                when (t) {
                    DocType.DELIVERY_NOTES.state -> {
                        getClientDeliveryNotes(ids = u.map { it.first }).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.ORDERS.state -> {
                        getClientOrderNotes(order_ids = u.map { it.first }, force = force).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.TAX_NOTE.state -> {
                        getClientTaxNote(ids = u.map { it.first }, type = 0).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.TAX_NOTE_CANCEL.state -> {
                        getClientTaxNote(ids = u.map { it.first }, type = 2).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.TAX_PAY_NOTE.state -> {
                        getClientTaxNote(ids = u.map { it.first }, type = 1).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.SUPPLIER_INVOICE.state -> {
                        getClientTaxNote(ids = u.map { it.first }, type = 0, sup = true).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.SUPPLIER_INVOICE_RECEIPT.state -> {
                        getClientTaxNote(ids = u.map { it.first }, type = 1, sup = true).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.SUPPLIER_INVOICE_CREDIT.state -> {
                        getClientTaxNote(ids = u.map { it.first }, type = 2, sup = true).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.VISIT.state -> {
                        buildClientVisitNote(ids = u.map { it.first }, full = full).first.forEach {
                            result.add(it)
                        }

                    }

                    DocType.PAY_NOTE.state -> {

                        getClientPay(
                            ids = u.map { it.first },
                        ).first.forEach {
                            result.add(it)
                        }
                    }


                }
            }
        } else {
            groups.forEach { (t, u) ->
                when (t) {
                    DocType.DELIVERY_NOTES.state -> {
                        buildClientNotes(delivery_ids = u.map { it.first }, full = full, api = full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.ORDERS.state -> {
                        buildClientOrderNotes(order_ids = u.map { it.first }, full = full, api = full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.TAX_NOTE.state -> {
                        buildClientTaxNote(ids = u.map { it.first }, type = 0, full = full,api=full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.TAX_NOTE_CANCEL.state -> {
                        buildClientTaxNote(ids = u.map { it.first }, type = 2, full = full,api=full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.TAX_PAY_NOTE.state -> {
                        buildClientTaxNote(ids = u.map { it.first }, type = 1, full = full,api=full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.SUPPLIER_INVOICE.state -> {
                        buildClientTaxNote(ids = u.map { it.first }, type = 0, sup = true, full = full, api = full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.SUPPLIER_INVOICE_RECEIPT.state -> {
                        buildClientTaxNote(ids = u.map { it.first }, type = 1, sup = true, full = full, api = full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.SUPPLIER_INVOICE_CREDIT.state -> {
                        buildClientTaxNote(ids = u.map { it.first }, type = 2, sup = true, full = full, api = full).first.forEach {
                            result.add(it)
                        }
                    }

                    DocType.VISIT.state -> {
                        buildClientVisitNote(ids = u.map { it.first }, full = full).first.forEach {
                            result.add(it)
                        }

                    }

                    DocType.PAY_NOTE.state -> {

                        buildClientPay(
                            ids = u.map { it.first },
                            full = full,
                            api=full
                        ).first.forEach {
                            result.add(it)
                        }
                    }


                }
            }
        }

        return Respone(result, DBQuery.SUCCESS)
    }


    suspend fun getLastUpdateEnt(params: HashMap<String, Any>): Respone<List<Int>, DBQuery> {
        return this.getLastUpdateEnt(
            action_time = params["action_time"] as String
        )
    }

    suspend fun getLastUpdateOrders(params: HashMap<String, Any>): Respone<List<OrderNote>, DBQuery> {
        val o = this.getLastUpdateOrders(
            action_time = params["action_time"] as String,
            date = params["date"] as String,
            full = false,
        )

        if (params["full"] as Boolean? ?: false && o.first.isNotEmpty()) {
            val full = buildFullClientOrderNotes(o.first, false, forceFetchPrice = true)
            val daily =
                buildClientsDailyData(
                    date = params["date"] as String,
                    ids = o.first.map { it.ent_id },
                    dailyFinder = true
                )
        }
        return Respone(o.first, o.second)
    }

    suspend fun getProductAvailable(params: HashMap<String, Any>): Respone<List<Available>, DBQuery> {
        val ids = params["ids"] as List<Int>?
        val product_ids = params["product_ids"] as List<Int>?
        val available = params["available"] as Int?
        val result = getProductAvailable(ids = ids, product_ids = product_ids, available = available)
        return Respone(result.first, result.second)
    }

    suspend fun newAllAvailable(params: HashMap<String, Any>): Respone<List<Available>, DBQuery> {
        val ids = params["ids"] as List<Int>
        val product_ids = params["product_ids"] as List<Int>
        val availables = params["availables"] as List<Int>?
        val available = params["available"] as Int?
        val data: MutableList<Available> = mutableListOf()
        ids.forEachIndexed { index, i ->
            product_ids.forEachIndexed { index2, j ->
                data.add(Available(i, j, availables?.get(index) ?: available ?: 1))
            }
        }


        val result = newAllAvailable(data = data)
        return Respone(result.first, result.second)
    }

    suspend fun copyClientAvailable(params: HashMap<String, Any>): Respone<List<Available>, DBQuery> {
        val from = params["from"] as Int
        val to = params["to"] as List<Int>
        val result = copyClientAvailable(from = from, to = to)
        return Respone(result.first, result.second)
    }

    suspend fun sendClientApi(params: HashMap<String, Any>): DBQuery {
        val doc_id = params["doc_id"] as List<Int>
        val doc_type = params["doc_type"] as List<Int>
        return sendClientApi(doc_id, doc_type)

    }

    suspend fun resetWhatsappConn(params: HashMap<String, Any>): DBQuery {
        val agent = params["agent"] as String?
        return resetWhatsappConn(agent)
    }
    suspend fun refreshHashIsrael(params: HashMap<String, Any>): DBQuery {
        return refreshHashIsrael()
    }

    suspend fun resetHashIsraelStoredTokens(params: HashMap<String, Any>): DBQuery {
        return resetHashIsraelStoredTokens()
    }

    suspend fun getClientCPData(params: HashMap<String, Any>): Respone<List<ClientProductData>, DBQuery> {
        val ids = params["ids"] as List<Int>?
        val productIds = params["productIds"] as List<Int>?
        val result = getClientCPData(ids, productIds)
        return Respone(result.first, result.second)
    }

    suspend fun setClientCPData(params: HashMap<String, Any>): Respone<List<ClientProductData>, DBQuery> {
        val ids = params["ids"] as List<Int>
        val productIds = params["productIds"] as List<Int>
        val barcodes = params["barcodes"] as List<String?>?
        val returns = (params["returns"] as? List<*>)?.map { item ->
            when (item) {
                null -> null
                is Number -> item.toFloat()
                else -> item.toString().trim().toFloatOrNull()
            }
        }
        return setClientCPData(ids, productIds, barcodes, returns)
    }

    suspend fun hashIsraelAuth(params: HashMap<String, Any>): DBQuery {
        val token = params["token"] as String
        val result = this.hashIsraelAuth(token = token)
        return result
    }

    suspend fun updateApiConfig(params: HashMap<String, Any>): DBQuery {
        val whatsapp = params["whatsapp"] as String
        val result = updateApiConfig(whatsappInstance = whatsapp)
        return result.second
    }

    suspend fun hashIsraelSign(params: HashMap<String, Any>): Respone<Pair<ClientTaxNote?, String>, DBQuery> {

        val result = this.hashIsraelSign(id = params["id"] as Int, type = params["type"] as Int)
        return result
    }

    suspend fun hashIsraelSignBulk(params: HashMap<String, Any>): Respone<List<Pair<ClientTaxNote?, String>>, DBQuery> {
        return this.hashIsraelSignBulk(
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?,
            ids = params["ids"] as List<Int>?,
            types = params["types"] as List<Int>?,
            sup = (params["sup"] as Boolean?) ?: false,
        )
    }

    suspend fun storeNextCompare(params: HashMap<String, Any>): Respone<String?, DBQuery> {

        val data: List<List<String>> = params["data"] as List<List<String>>
        val header = data.first()

        val map: MutableMap<String, Int> = mutableMapOf()
        header.forEachIndexed { index, s ->
            map[s.trim()] = index
        }

        val date: String = params["date"] as String
        val store = storeNextLoader(data.drop(1).filter { it.isNotEmpty() }, map, date)
        store.init()
        store.load(date)

        store.finish()

        return Respone(store.writeToJsonStr(), DBQuery.SUCCESS)
    }

    suspend fun readMimshak(params: HashMap<String, Any>): DBQuery {
        val date = params["to_date"] as String?
        val result = readMimshak(date)
        return result
    }


    suspend fun updateMassDocument(params: HashMap<String, Any>): Respone<List<InformationBase>, DBQuery> {
        val data = params["data"] as List<ChangeNoteHelper>
        val orders = mutableListOf<Int>()
        val orders_pds = mutableListOf<List<ProductDelivery>>()
        val delivery = mutableListOf<Int>()
        val delivery_pds = mutableListOf<List<ProductDelivery>>()
        val sup = mutableListOf<Int>()
        val sup_pds = mutableListOf<List<ProductDelivery>>()
        val savePriceInNote = getUser().first?.savePriceInNote() == true
        val savePriceInClient = params["savePriceInClient"] as Boolean? ?: true
        val updatePrices: MutableList<RawPrice> = mutableListOf()
        val updateDrivers: MutableList<ClientDailyData> = mutableListOf()
        val delivery_ids = data.filter { it.docType == DocType.DELIVERY_NOTES.state }.map { it.doc_id }.distinct()
//        if (delivery_ids.isNotEmpty())
//            buildClientNotes(delivery_ids = delivery_ids, full = true)

        val order_ids = data.filter { it.docType == DocType.ORDERS.state }.map { it.doc_id }.distinct()
//        if (order_ids.isNotEmpty())
//            buildClientOrderNotes(order_ids = order_ids, full = true)

        val sup_ids = data.filter { it.docType == DocType.SUP_DELIVERY_NOTES.state }.map { it.doc_id }.distinct()
//        if (sup_ids.isNotEmpty())
//            buildSupplierNotes(delivery_ids = sup_ids, full = true)
        val curDate = DatesManipulator.dateNowNoHour()
        val drivers = getAgents().first.filter { it.isDriver() }

        data.filter { it.docType == DocType.DELIVERY_NOTES.state || it.docType == DocType.ORDERS.state || it.docType == DocType.SUP_DELIVERY_NOTES.state }
            .groupBy { Pair(it.doc_id, it.docType) }.forEach {
                val note = when (it.key.second) {
                    DocType.DELIVERY_NOTES.state -> {
                        getClientDeliveryNotes(delivery_id = it.key.first).first.firstOrNull()

                    }

                    DocType.ORDERS.state -> {
                        getClientOrderNotes(order_id = it.key.first).first.firstOrNull()
                    }

                    DocType.SUP_DELIVERY_NOTES.state -> {
                        getSupplierDeliveryNotes(delivery_id = it.key.first).first.firstOrNull()
                    }

                    else -> null
                }

                if (note != null) {
                    val ent = note.getEnt(it.key.second != DocType.SUP_DELIVERY_NOTES.state)
                    val newDelivery = mutableListOf<ProductDelivery>()
                    val seen = mutableMapOf<Int, ProductDelivery>()
                    val changes = it.value
                    note.delivery_info.forEachIndexed { index, pd ->
                        seen[pd.productId] = pd

                    }
                    val driver_id = note.driver_id
                    val curDriver = if (driver_id != null && driver_id != -1) {
                        drivers.firstOrNull { it.id == driver_id }
                    } else null
                    val cps = changes.map { it.driver }
                        .filter { it != null && it != "" && (curDriver == null || curDriver.user_name != it) }
                        .distinct().mapNotNull {
                            drivers.firstOrNull { d -> d.user_name == it }
                        }
                    if (cps.isNotEmpty()) {
                        cps.forEach { cp ->
                            updateDrivers.add(
                                ClientDailyData(
                                    note.date,
                                    ent.id,
                                    cp.id,
                                    0,
                                    0,
                                    0,
                                    0, "", 0
                                )
                            )


                        }
                    }



                    changes.forEach { cn ->
                        if (cn.p_id in seen) {
                            val curPd = seen[cn.p_id]!!
                            val price = ent.getPrice(cn.p_id)!!.get(note.date)
                            var use_price: Byte? = null
                            if (cn.price!=0f &&(price.first != cn.price || price.second != cn.discount )) {
                                updatePrices.add(
                                    RawPrice(
                                        if (ent is Client) (ent.masterBranch?.id ?: ent.id) else ent.id,
                                        curPd.productId,
                                        cn.price,
                                        if (note.date <= unclosed_date) curDate else note.date,
                                        cn.discount
                                    )
                                )
                                if (ent.hasPriceControl()) {
                                    use_price = ProductDelivery.createUsedState(
                                        curPd.getProduct().no_tax_product,
                                        ent.no_tax_client,
                                        ent.getIncludeTax()
                                    )

                                }
                            }
                            val pds = curPd.copy(
                                value = cn.amount,
                                returns = cn.returns,
                                price = cn.price,
                                discount = cn.discount,
                                wrapped_amount = cn.amountSecond,
                                conversion_ratio = if (cn.amount > 0 && cn.amountSecond > 0) 0f else cn.conversion_rate,
                                use_price = use_price ?: curPd.use_price,
                            )
                            seen[(cn.p_id)] = pds

                        } else {
                            val pds = ProductDelivery(
                                cn.p_id,
                                cn.amount,
                                cn.returns,
                                cn.price,
                                discount = cn.discount,
                                wrapped_amount = cn.amountSecond,
                                conversion_ratio = if (cn.amount > 0 && cn.amountSecond > 0) 0f else cn.conversion_rate,

                                )

                            seen[(cn.p_id)] = pds

                        }


                    }
                    seen.forEach {
                        if (!it.value.empty())
                            newDelivery.add(it.value)
                    }
                    when (it.key.second) {
                        DocType.DELIVERY_NOTES.state -> {
                            delivery.add(it.key.first)
                            delivery_pds.add(newDelivery)
                        }

                        DocType.ORDERS.state -> {
                            orders.add(it.key.first)
                            orders_pds.add(newDelivery)
                        }

                        DocType.SUP_DELIVERY_NOTES.state -> {
                            sup.add(it.key.first)
                            sup_pds.add(newDelivery)
                        }
                    }


                }

            }

        val res: MutableList<InformationBase> = mutableListOf()
        if (savePriceInClient && updatePrices.isNotEmpty()) {
            updateAllClientProductPrice(curDate, updatePrices)
        }
        if (updateDrivers.isNotEmpty()) {
            newClientAllDailyData(daily = updateDrivers, onlyDriver = true)
        }


        if (delivery.isNotEmpty() && delivery_ids.size == delivery.size) {
            val result = updateAllClientNotes(
                delivery_ids = delivery,
                pds = delivery_pds,
                full = savePriceInClient && updatePrices.isNotEmpty()
            )
            if (result.second != DBQuery.SUCCESS) return Respone(result.first, result.second)
            res.addAll(result.first)
        }
        if (sup.isNotEmpty() && sup_ids.size == sup.size) {

        }
        if (orders.isNotEmpty() && order_ids.size == orders.size) {
            val result = updateAllClientOrders(
                order_ids = orders,
                pds = orders_pds,
                full = savePriceInClient && updatePrices.isNotEmpty()
            )
            res.addAll(result.first)
            if (result.second != DBQuery.SUCCESS) return Respone(res, result.second)

        }


        val updateCostPrices: MutableList<RawPrice> = mutableListOf()
        //cost
        data.mapNotNull {
            if (it.cost != null && it.date != null && (it.docType == DocType.DELIVERY_NOTES.state || it.docType == DocType.ORDERS.state))
                Triple(it.p_id, it.date, it.cost)
            else
                null

        }.forEach {
            val p_id = it.first
            val date = it.second
            val cost = it.third

            updateCostPrices.add(
                RawPrice(
                    -1,
                    p_id,
                    cost,
                    date,
                    0f
                )
            )
        }
        printPlat(updateCostPrices)
        if (updateCostPrices.isNotEmpty())
            return Respone(
                res,
                updateAllClientProductPrice(updateCostPrices.first().date, updateCostPrices, null, null, null)
            )


        return Respone(res, DBQuery.SUCCESS)
    }

    suspend fun getDeposits(params: HashMap<String, Any>): Respone<List<Deposit>, DBQuery> {
        return this.buildDeposits(
            fromDate = params["fromDate"] as? String,
            toDate = params["toDate"] as? String,
            id = params["id"] as? Int,
            ids = params["ids"] as? List<Int>,
            status = params["status"] as? Int,
            source_type = params["source_type"] as? Int,
            bank_account_id = params["bank_account_id"] as? Int,
            min_id = params["min_id"] as? Int,
        )
    }

    suspend fun updateHashavshevetBankAccounts(params: HashMap<String, Any>): Respone<HashavshevetS?, DBQuery> {
        return this.updateHashavshevetBankAccounts(
            bank_accounts = params["bank_accounts"] as String,
            deposit_move = params["deposit_move"] as? String,
        )
    }

    /**
     * Lines arrive as a JSON array string rather than as constructed objects: the
     * web caller already knows every field, and a string needs no JS-side factory
     * or interop shim to build.
     */
    suspend fun newDeposit(params: HashMap<String, Any>): Respone<Deposit?, DBQuery> {
        val lines = DepositLine.createFromJson(params["lines_raw"] as? String)
        return this.newDeposit(
            deposit_date = params["deposit_date"] as String,
            lines = lines,
            bank_account_id = (params["bank_account_id"] as? Int) ?: 0,
            source_type = (params["source_type"] as? Int) ?: DEPOSIT_SOURCE_CASH,
            notes = params["notes"] as? String,
            paid_details = params["paid_details"] as? String,
        )
    }

    suspend fun cancelDeposit(params: HashMap<String, Any>): Respone<Deposit?, DBQuery> {
        return this.cancelDeposit(id = params["id"] as Int)
    }

    suspend fun getPriceOffers(params: HashMap<String, Any>): Respone<List<PriceOffer>, DBQuery> {
        return this.getPriceOffers(
            number = params["number"] as? Int,
            id = params["id"] as? Int,
            client_id = params["client_id"] as? Int,
            ids = params["ids"] as? List<Int>,
            last10 = params["last10"] as? Boolean ?: false,
        )
    }

    suspend fun newPriceOffer(params: HashMap<String, Any>): Respone<PriceOffer?, DBQuery> {
        return this.newPriceOffer(
            client_id = (params["client_id"] as? Int) ?: -1,
            date = params["date"] as String,
            products = params["products"] as String,
            name = params["name"] as String,
        )
    }

    suspend fun updatePriceOffer(params: HashMap<String, Any>): Respone<PriceOffer?, DBQuery> {
        return this.updatePriceOffer(
            id = params["id"] as Int,
            client_id = params["client_id"] as? Int,
            date = params["date"] as? String,
            products = params["products"] as? String,
            name = params["name"] as? String,
        )
    }

    suspend fun calcPriceOfferPdf(params: HashMap<String, Any>): Respone<ByteArray?, DBQuery> {
        return this.calcPriceOfferPdf(
            ids = params["ids"] as List<Int>,
            pdf_output_mode = params["pdf_output_mode"] as? String,
            price_cols = params["price_cols"] as? String,
        )
    }

    suspend fun attendanceClockIn(params: HashMap<String, Any>): Respone<String?, DBQuery> {
        val uid = when (val v = params["user_id"]) {
            is Int -> v
            is Number -> v.toInt()
            is String -> v.toIntOrNull()
            else -> null
        } ?: return Respone(null, DBQuery.FAILED)
        val userName = params["user_name"] as? String ?: return Respone(null, DBQuery.FAILED)
        val loc = (params["clock_in_location"] as? String)?.trim()?.takeIf { it.isNotEmpty() }
        val disp = (params["agent_display_name"] as? String)?.trim()?.takeIf { it.isNotEmpty() }
        val scan = (params["scan_code"] as? String)?.trim()?.takeIf { it.isNotEmpty() }
        val image = (params["image_base64"] as? String)?.trim()?.takeIf { it.isNotEmpty() }
        return attendanceClockIn(uid, userName, loc, disp, scan, image)
    }

    suspend fun attendanceClockOut(params: HashMap<String, Any>): Respone<String?, DBQuery> {
        val userId = when (val v = params["user_id"]) {
            is Int -> v
            is Number -> v.toInt()
            is String -> v.toIntOrNull()
            else -> null
        } ?: return Respone(null, DBQuery.FAILED)
        val attendanceId = when (val v = params["attendance_id"]) {
            is Int -> v
            is Number -> v.toInt()
            is String -> v.toIntOrNull()
            else -> null
        }
        return attendanceClockOut(
            userId = userId,
            attendanceId = attendanceId,
            location = (params["clock_in_location"] as? String)?.trim()?.takeIf { it.isNotEmpty() },
            scanCode = (params["scan_code"] as? String)?.trim()?.takeIf { it.isNotEmpty() },
            imageBase64 = (params["image_base64"] as? String)?.trim()?.takeIf { it.isNotEmpty() },
        )
    }

    suspend fun getAttendance(params: HashMap<String, Any>): Respone<String?, DBQuery> {
        val uid: Int? = when (val v = params["user_id"]) {
            null -> null
            is Int -> v
            is Number -> v.toInt()
            is String -> v.toIntOrNull()
            else -> null
        }
        return getAttendance(
            userId = uid,
            fromDate = params["fromDate"] as String?,
            toDate = params["toDate"] as String?
        )
    }

    suspend fun attendanceUpdate(params: HashMap<String, Any>): DBQuery {
        return attendanceUpdate(
            attendanceId = params["attendance_id"] as Int,
            clockIn = params["clock_in"] as String?,
            clockOut = params["clock_out"] as String?,
            date = params["date"] as String?,
            userName = params["user_name"] as String?,
        )
    }
}

















